import { Workbook } from 'exceljs';

export default {
  /**
   * Trạng thái của form
   */
  FormState: {
    Add: 'Thêm',
    View: 'Xem',
    Edit: 'Sửa',
    Duplicate: 'Thêm',
    QuickAdd: 'Thêm nhanh',
    Estimate: 'Lập dự toán',
    Getdata: 'Lấy dữ liệu',
  },
  TrackingFilter: {
    DeliverDecision: 'Quyết định giao',
    BeginningEstimate: 'Dự toán đầu năm',
  },
  /**
   * Tháng
   */
  Month: {
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
  },

  /**
   * Quý
   */
  Quarter: {
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
  },
  ReportingPeriod: {
    Month: 'Tháng',
    Quarter: 'Quý',
    Year: 'Năm',
    Custom: 'Tùy chọn',
  },
  /**
   * Giới tính
   */
  Gender: {
    Female: 'Nữ',
    Male: 'Nam',
    Other: 'Khác',
  },
  InDebt: {
    Debt: 'Dư nợ',
    ExcessYes: 'Dư có',
  },
  /**
   * toán tử filter
   */
  FilterOperator: {
    Contains: 'Chứa',
    Notcontains: 'Không chứa',
    StartsWith: 'Bắt đầu với',
    EndsWith: 'Kết thúc với',
    Null: '(Trống)',
    NotNull: '(Không trống)',
    Equals: 'Bằng',
    NotEquals: 'Khác',
    GreaterThan: 'Lớn hơn',
    GreaterThanEquals: 'Lớn hơn hoặc bằng',
    LessThan: 'Nhỏ hơn',
    LessThanEquals: 'Nhỏ hơn hoặc bằng',
    Between: 'Trong khoảng',
  },

  OrganizationUnitType: {
    Corporations: 'Tổng công ty',
    Group: 'Tập đoàn',
    Subsidiaries: 'Công ty con',
    Branch: 'Chi nhánh',
    Representative: 'Văn phòng đại điện',
    Office: 'Văn phòng',
    Center: 'Trung tâm',
    Department: 'Phòng ban',
    Team: 'NHóm/tổ/đội',
    Factory: 'Phân xưởng',
  },
  EmployeeType: {
    Probation: 'Thử việc',
    Office: 'Chính thức',
    Manage: 'Quản lý',
  },
  Period: {
    ThisDay: 'Hôm nay',
    ThisWeek: 'Tuần này',
    FirstWeekToPresent: 'Đầu tuần tới hiện tại',
    ThisMonth: 'Tháng này',
    FirstMonthToPresent: 'Đầu tháng tới hiện tại',
    ThisQuarter: 'Quý này',
    FirstQuarterToPresent: 'Đầu quý tới hiện tại',
    ThisYear: 'Năm nay',
    FirstYearToPresent: 'Đầu năm tới hiện tại',
    SixFirstMonth: 'Sáu tháng đầu năm',
    SixLastMonth: 'Sáu tháng cuối năm',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    FiscalI: 'Quý 1',
    FiscalII: 'Quý 2',
    FiscalIII: 'Quý 3',
    FiscalIV: 'Quý 4',
    Yesterday: 'Hôm qua',
    LastWeek: 'Tuần trước',
    LastMonth: 'Tháng trước',
    LastQuarter: 'Quý trước',
    LastYear: 'Năm trước',
    Tomorrow: 'Ngày mai',
    NextWeek: 'Tuần sau',
    NextMonth: 'Tháng sau',
    NextQuarter: 'Quý sau',
    NextYear: 'Năm sau',
    Custom: 'Tùy chọn',
  },
  AccountCategoryKind: {
    Debit: 'Dư Nợ',
    Credit: 'Dư Có',
    BothSide: 'Lưỡng tính',
  },
  Currency: {
    VND: 'VND',
    Dola: 'USD',
  },
  Pagination: {
    // Two: '2 bản ghi trên 1 trang',
    Ten: '10 bản ghi trên 1 trang',
    Twen: '20 bản ghi trên 1 trang',
    Thir: '30 bản ghi trên 1 trang',
    Fif: '50 bản ghi trên 1 trang',
    Hunder: '100 bản ghi trên 1 trang',
  },
  SalaryForm: {
    Coefficient: 'Hệ số',
    Amount: 'Số tiền',
  },
  MethodDistributeType: {
    Budget: 'Dự toán',
    TreasuryWarrant: 'Lệnh chi',
    InKind: 'Hiện vật',
    RecordReceiptExpense: 'Ghi thu - Ghi chi',
    Other: 'Khác',
  },
  CashWithDrawType: {
    None: 'Không chọn',
    EstimateAdvance: 'Tạm ứng đã cấp dự toán',
    EstimateNotYetAdvance: 'Tạm ứng chưa cấp dự toán',
    AdvancePayment: 'Thanh toán tạm ứng',
    Expense: 'Thực chi', // sửa theo comment của a tú
    PlanReceipt: 'Nhận dự toán',
    TreasuryWarrantReceipt: 'Nhận lệnh chi tạm ứng',
    ReceiptExpense: 'Ghi thu - Ghi chi',
    TreasuryWarrantReceiptExpense: 'Nhận lệnh chi thực chi',
    ExpenseReduce: 'Giảm chi - Thực chi',
    ExpenseReduceAdvance: 'Giảm chi - Tạm ứng',
    RefundExpense: 'Nộp trả - Thực chi',
    RefundAdvance: 'Nộp trả - Tạm ứng',
    Supplement: 'Bổ sung',
    RestoreExpense: 'Nộp phục hồi - Thực chi',
    RestoreAdvance: 'Nộp phục hồi - Tạm ứng',
    BudgetRejecttion: 'Xuất toán',
    ReceiptBudgetReturn: 'Giảm thu',
    IncrementAdjustment: 'Điều chỉnh tăng thuế GTGT',
    DecrementAdjustment: 'Điều chỉnh giảm thuế GTGT',
    DestroyPlanning: 'Hủy dự toán',
    BUPlanAdjustment: 'Điều chỉnh',
    DestroyReceipt: 'Hủy lệnh chi tiền',
    ReceiptForInferior: 'Lệnh chi cho cấp dưới',
    ReceivedReceiptFromSuperiors: 'Lệnh chi nhận từ cấp trên',
  },
  RefType: {
    BUTransfer: 'Chuyển khoản kho bạc',
    BUTransferDeposit: 'Chuyển khoản kho bạc vào TK tiền gửi',
    BUPlanWithdrawDeposit: 'Rút dự toán tiền gửi',
    BUPlanWithdrawCash: 'Rút dự toán tiền mặt',
    BUPlanWithdrawTransfer: 'Rút dự toán chuyển khoản',
    BUPlanWithdrawSalaryTransfer: 'Rút dự toán chuyển khoản lương, bảo hiểm',
    BUPlanReceipt: 'Nhận dự toán đầu năm',
    BUPlanReceiptSuplementary: 'Nhận dự toán bổ sung',
    CAReceiptSale: 'Phiếu thu bán hàng',
    CAReceipt: 'Phiếu thu',
    CAReceiptWithdraw: 'Phiếu thu rút tiền gửi NH, KB',
    CAReceiptPlanWithdraw: 'Phiếu thu rút dự toán nhập quỹ',
    CAReceiptFixedAsset: 'Phiếu thu bán tài sản cố định',
    BUPlanSupplement: 'Nhận dự toán bổ sung',
    BUPlanCancel: 'Hủy dự toán',
    BUVoucherListPlanned: 'Bảng kê chứng từ thanh toán đã cấp dự toán',
    BUVoucherListNotPlanned: 'Bảng kê chứng từ thanh toán chưa cấp dự toán',
    BUVoucherListReceipExpense: 'Bảng kê chứng từ thanh toán ghi thu - ghi chi',
    BUVoucherListOther: 'Bảng kê chứng từ khác',
    BUVoucherListRealExpense: 'Bảng kê chứng từ thanh toán thực chi',
    BUPlanAdjustment: 'Điều chỉnh dự toán',
    SUTransfer: 'Điều chỉnh CCDC',
    SUIncrement: 'Ghi tăng CCDC',
    SUDecrement: 'Ghi giảm CCDC',
    BUPlanAdjustment: 'Điều chỉnh dự toán',
    PUInvoice: 'Hóa đơn mua hàng',
    INTransfer: 'Chuyển kho',
    INAdjustment: 'Điều chỉnh tồn kho',
    INOutward: 'Xuất kho',
    INInward: 'Nhập kho',
    BADeposit: 'Thu tiền gửi',
    BUExpenseWithdrawAdjustment: 'Điều chỉnh kinh phí',
    CAPaymentVendor: 'Phiếu chi trả nhà cung cấp',
    CAPaymentPurchase: 'Phiếu chi mua vật tư hàng hóa',
    SAInvoice: 'Bán hàng chưa thu tiền',
    BABankTransfer: 'Chuyển tiền nội bộ',
    BAWithdrawPurchase: 'Chi tiền gửi mua Vật tư, hàng hóa',
    CAPayment: 'Phiếu chi',
    CAPaymentDeposit: 'Phiếu chi nộp vào NH, KB',
    CAPaymentSalary: 'Phiếu chi là Phiếu chi trả lương',
    CAPaymentFixedAsset: 'Phiếu chi mua tài sản cố định',
    BAWithDraw: 'Chi tiền gửi',
    GLGeneralVoucher: 'Chứng từ nghiệp vụ khác',
    BUBudgetReserve: 'Dự toán giữ lại',
    GLBeginningYearTransfer: 'Quyết toán số dư đầu năm',
    CAReceiptCustomer: 'Phiếu thu tiền khách hàng',
    GLProfitLossTransfer: 'Xác định kết quả hoạt động',
    GLEndYearTransfer: 'Kết chuyển số dư cuối năm',
    GLProvisionalTaxInComeEnterprise: 'Tạm tính thuế thu nhập doanh nghiệp',
    GLFinalTaxInComeEnterprise: 'Quyết toán thuế thu nhập doanh nghiệp',
    SAReturn: 'Hàng bán trả lại',
    BUCommitmentRequest: 'Đề nghị cam kết chi',
    BUCommitmentAdjustment: 'Điều chỉnh cam kết chi',
    GLVoucherSummaryTable: 'Bảng tổng hợp chứng từ cùng loại',
    GLPostedVoucher: 'Chứng từ ghi sổ',
    BATransferDeposit: 'Tiền đang chuyển đến',
    BATransferWithdraw: 'Tiền đang chuyển đi',
    FAVoucherDepreciation: 'Lấy hao mòn tự nhiên TSCĐ từ QLTS.VN',
    FAVoucherIncreament: 'Ghi tăng TSCĐ từ QLTS.VN',
    FAVoucherAdjustment: 'Đánh giá lại TSCĐ từ QLTS.VN',
    FAVoucherDepreciate: 'Lấy khấu hao TSCĐ từ QLTS.VN',
    FAVoucherDecrement: 'Ghi giảm TSCĐ từ QLTS.VN',
    BUTransferPurchase: 'Chuyển khoản kho bạc mua vật tư hàng hóa',
    INInwardFromINAdjustment: 'Nhập kho từ điều chỉnh tồn kho',
    INInwardFromINAdjustmentChangeAmount: 'Nhập kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)',
    INOutwardFromINAdjustment: 'Xuất kho từ điều chỉnh tồn kho',
    INOutwardFromINAdjustmentChangeAmount: 'Xuất kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)',
    BADepositSale: 'Thu tiền gửi từ bán hàng',
    BADepositCustomer: 'Thu tiền gửi từ khách hàng',
    BUOpeningCommitment: 'Số dư ban đầu cam kết chi',
    BAWithdrawVendor: 'Chi tiền gửi trả nhà cung cấp',
    BUTransferVendorPayment: 'Chuyển khoản kho bạc trả nhà cung cấp',
    BUTransferSalary: 'Chuyển khoản kho bạc trả lương',
    BUTransferInsurrance: 'Chuyển khoản kho bạc thanh toán bảo hiểm',
    BUTransferFixedAsset: 'Chuyển khoản kho bạc mua tài sản cố định',
    BUTreasuryFundTransferSalary: 'Chuyển khoản trả lương',
    BUTreasuryFundTransferInsurancePayment: 'Chuyển khoản thanh toán bảo hiểm',
    BAWithDrawSalary: 'Chi tiền gửi trả lương',
    BAWithDrawFixedAsset: 'Chi tiền gửi mua tài sản cố định',
  },
  ActivityType: {
    AbsoluteIndependent: 'Đơn vị hành chính được giao tự chủ kinh phí',
    NoFinancialAutonomy: 'Đơn vị hành chính không được giao tự chủ kinh phí',
    RelativeIndependent: 'Đơn vị SNCL tự chủ một phần chi thường xuyên',
    Depedent: 'Đơn vị SNCL do NSNN cấp kinh phí',
    NormalExpenditureAndInvest: 'Đơn vị SNCL tự chủ chi thường xuyên và đầu tư',
    NormalExpenditure: 'Đơn vị SNCL tự chủ chi thường xuyên',
  },
  Particular: {
    General: 'Không chọn',
    Science: 'Bộ khoa học',
    Statistic: 'Tổng cục thống kê',
    DangAudit: 'Kế toán Đảng',
    StateAudit: 'Kế toán nhà nước',
    SGDHaiDuong: 'Sở giáo dục tỉnh Hải Dương',
    STCLongAn: 'Sở tài chính Long An',
  },
  TaxRate: {
    ZeroPercent: '0%',
    FivePercent: '5%',
    EightPercent: '8%',
    TenPercent: '10%',
  },
  TaxRateInventory: {
    NoSelected: 'KCT',
    ZeroPercent: '0%',
    FivePercent: '5%',
    EightPercent: '8%',
    TenPercent: '10%',
  },
  InvType: {
    // Loại Hóa đơn
    NoInvoice: 'Không có hóa đơn',
    NormalInvoice: 'Hóa đơn thông thường',
    InvoiceGTGT: 'Hóa đơn GTGT',
  },
  GovSource: {
    General: 'Không chọn',
    DomesticExpenditure: 'Nguồn chi từ vốn trong nước',
    ForeignExpenditure: 'Nguồn chi từ vốn ngoài nước',
  },
  BudgetItemType: {
    Group: 'Nhóm',
    SubGroup: 'Tiểu nhóm',
    Item: 'Mục',
    SubItem: 'Tiểu mục',
    SubSection: 'Tiết tiểu mục',
  },
  AccountTransferBusinessType: {
    BalanceTransferYear: 'Kết chuyển số dư cuối năm',
    PerformanceResultDefined: 'Xác định kết quả hoạt động',
  },
  ProjectType: {
    IntermAccountingUnitSt: 'Đơn vị kế toán trung gian 1',
    IntermAccountingUnitNd: 'Đơn vị kế toán trung gian 2',
    EstimatedUnitsSt: 'Đơn vị dự toán cấp 1',
    OutEstimatedUnitsStInProv: 'Ngoài đơn vị dự toán cấp 1 - trong cùng 1 tỉnh',
    OutEstimatedUnitsStDiffProv:
      'Ngoài đơn vị dự toán cấp 1 (khác tỉnh, khác Bộ, ngành) - trong lĩnh vực kế toán nhà nước',
    OutGovernmArea: 'Ngoài khu vực nhà nước',
  },
  AccountTransferTransferSide: {
    InDebt: 'Nợ',
    Yes: 'Có',
    BothSides: 'Hai bên',
  },
  ExecuteAction: {
    NoAction: 'Không xử lý',
    Inward: 'Nhập kho',
    Outward: 'Xuất kho',
  },
  OutwardPurpose: {
    OutwardUsed: 'Xuất dùng',
    OutwardSale: 'Xuất bán',
    OutwardOther: 'Xuất khác',
  },
  BudgetSourceKindType: {
    ActivityFund: 'Kinh phí hoạt động',
    RegularFund: 'Kinh phí thường xuyên',
    IrregularFund: 'Kinh phí không thường xuyên',
    ProjectFund: 'Kinh phí dự án',
    OrderPublicFund: 'Kinh phí theo đơn đặt hàng nhà nước',
    BasicConstructFund: 'Kinh phí xây dựng cơ bản',
    InvestmentFund: 'Kinh phí tổng điều tra',
    PriorityFund: 'Kinh phí ưu đãi người có công',
    NotReturnFund: 'Kinh phí viện trợ không hoàn lại',
    DebtForeignFund: 'Kinh phí vay nợ nước ngoài',
  },
  DictionaryFeesType: {
    Fee: 'Phí',
    Fees: 'Lệ phí',
  },

  /**
   * Loại thu phí lệ phí
   */
  FeesType: {
    All: 'Tất cả',
    Fee: 'Phí',
    ChargeFee: 'Lệ phí',
  },

  /**
   * Tính chất hoạt động chi nguồn NSNN
   */
  ExpenseNSNNType: {
    All: 'Tất cả',
    SelfControl: 'Kinh phí thực hiện chế độ tự chủ',
    NotSelfControl: 'Kinh phí không thực hiện chế độ tự chủ',
  },

  /**
 * Nhóm tiêu chí
 */
  CriteriaGroupType: {
    ProfessionalBusiness: 'Nghiệp vụ chuyên môn',
    AssetRepair: 'Sửa chữa tài sản',
    AssetPurchase: 'Mua sắm tài sản',
    Other: 'Khác',
  },

  /**
   * Tháng thực hiện
   */
  ImplementMonth: {
    All: 'Tất cả',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
  },

  /**
   * Tháng thực hiện
   */
  ImplementMonthCQSN: {
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    Year: 'Năm'
  },

  EstimateRevenueOtherType: {
    in: 'Thu khác theo quy định của pháp luật thuộc cân đối NSĐP',
    out: 'Thu khác theo quy định của pháp luật ngoài cân đối NSĐP',
  },

  InvoiceFormNumberType: {
    VatInvoice: 'Hóa đơn giá trị gia tăng',
    Bill: 'Hóa đơn bán hàng',
    DeliveryBillFreight: 'Phiếu xuất kho kiêm vận chuyển hàng hóa nội bộ',
    DeliveryBillAgentSales: 'Phiếu xuất kho gửi bán hàng đại lý',
    ExportBill: 'Hóa đơn xuất khẩu',
    BillOfSale: 'Hóa đơn bán hàng (dành cho tổ chức, cá nhân trong khu phi thuế quan)',
    ElecInvoicePublicProperty: 'Hóa đơn điện tử bán tài sản công',
    ElecInvoiceNationalReserves: 'Hóa đơn điện tử bán hàng dự trữ quốc gia',
    DiffBills: 'Hóa đơn khác (tem, vé, thẻ...)',
    Documents: 'Chứng từ như hóa đơn (PXK kiêm vận chuyển nội bộ, PXK hàng gửi bán đại lý)',
  },
  ReportPeriod: {
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: '6 tháng đầu năm',
    SecondHalfYear: '6 tháng cuối năm',
    Year: 'Cả năm',
    ThisMonth: 'Tháng này',
    ThisQuarter: 'Quý này',
    Custom: 'Tùy chọn',
  },
  InvoiceForm: {
    SeftPrintInvoice: 'Hóa đơn tự in',
    OrderPrintInvoice: 'Hóa đơn đặt in',
    ElectronicInvoice: 'Hóa đơn điện tử',
  },
  /**
   * Loại hợp đồng
   */
  ContractType: {
    Purchase: 'Hợp đồng mua',
    Sale: 'Hợp đồng bán',
    General: 'Không chọn',
  },
  StageImplement: {
    Stage: 'Theo giai đoạn',
    Annualy: 'Hàng năm',
  },
  ObjectType: {
    Construction: 'Công trình',
    WorkItem: 'Hạng mục công trình',
  },
  TypeEstimate: {
    FirstOfYear: 'Đầu năm',
    Addition: 'Bổ sung',
  },
  ReportCre: {
    MonthDecember: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: '6 tháng đầu năm',
    SecondHalfYear: '6 tháng cuối năm',
    Year: 'Cả năm',
  },
  AutoBusinessType: {
    Auto: 'Mặc định',
    SelfSetting: 'Tự thiết lập',
  },
  /**
   * Giai đoạn đầu tư
   */
  InvestmentPeriod: {
    PrepareInvest: 'Giai đoạn chuẩn bị đầu tư',
    PerformInvest: 'Giai đoạn thực hiện đầu tư',
    EndInvest: 'Giai đoạn kết thúc xây dựng, đưa dự án vào khai thác sử dụng',
    Costs: 'Chi phí Ban quản lý dự án',
  },
  /**
   * Hình thức sổ kế toán
   */
  AccountingForm: {
    // Summary: 'Tổng hợp',
    SharedDiary: 'Nhật ký chung',
    LedgerDiary: 'Nhật ký - sổ cái',
    LicenseRecord: 'Chứng từ ghi sổ',
  },
  /**
   * Kí hiệu tiền tệ
   */
  MoneySign: {
    NormalVND: 'đ',
    UpperCaseVND: 'Đ',
    Dola: '$',
    Eur: 'EUR',
    None: 'Không chọn',
  },
  /**
   * Ký tự ngăn cách
   */
  Separator: {
    Dot: '. (dấu chấm)',
    Comma: ', (dấu phẩy)',
  },

  TypeAllocationPending: {
    ExpenseInvest: 'Chi đầu tư phát triển',
    ExpenseProject: 'Chi CTMT, mục tiêu khác',
    ExpenseRegular: 'Chi thường xuyên',
  },
  /**
   * Định dạng số dương
   */
  PositiveFormat: {
    $n: '$n',
    '$ n': '$ n',
    n$: 'n$',
    'n $': 'n $',
  },
  /**
   * Định dạng số âm
   */
  NegativeFormat: {
    '($n)': '($n)',
    '-$n': '-$n',
    '$-n': '$-n',
    '$n-': '$n-',
    '(n$)': '(n$)',
    '-n $': '-n $',
    'n-$': 'n-$',
    'n $-': 'n $-',
    '-$ n': '-$ n',
    '$ n-': '$ n-',
    'n- $': 'n- $',
    '($ n)': '($ n)',
    '(n $)': '(n $)',
  },
  /**
   * Hệ thống tùy chỉnh ngầm định nghiệp vụ
   */
  DefaultConfigBusiness: {
    None: 'Không chọn',

    AdvanceDistributed: 'Tạm ứng đã cấp dự toán',

    AdvanceUndistributed: 'Tạm ứng chưa cấp dự toán',

    AdvancePayment: 'Thanh toán tạm ứng',

    Expense: 'Thực chi',

    PlanReceipt: 'Nhận dự toán',

    TreasuryWarrantReceipt: 'Nhận lệnh chi tạm ứng',

    ReceiptExpense: 'Ghi thu, ghi chi',

    TreasuryWarrantReceiptExpense: 'Nhận lệnh chi thực chi',

    ExpenseReduce: 'Giảm chi - Thực chi',

    ExpenseReduceAdvance: 'Giảm chi - Tạm ứng',

    RefundExpense: 'Nộp trả - Thực chi',

    RefundAdvance: 'Nộp trả - Tạm ứng',

    Supplement: 'Bổ sung',

    RestoreExpense: 'Nộp phục hồi - Thực chi',

    RestoreAdvance: 'Nộp phục hồi - Tạm ứng',

    BudgetRejecttion: 'Xuất toán',

    ReceiptBudgetReturn: 'Giảm thu',

    IncrementAdjustment: 'Điều chỉnh tăng thuế GTGT',

    DecrementAdjustment: 'Điều chỉnh giảm thuế GTGT',

    DestroyPlanning: 'Hủy dự toán',

    BUPlanAdjustment: 'Điều chỉnh dự toán',

    DestroyReceipt: 'Hủy lệnh chi tiền',

    ReceiptForInferior: 'Lệnh chi cấp cho cấp dưới',

    ReceivedReceiptFromSuperiors: 'Lệnh chi nhận từ cấp trên',
  },
  /**
   * Hình thức cấp phát
   */
  AllocationFormat: {
    Budget: 'Dự toán',

    TreasuryWarrant: 'Lệnh chi',

    InKind: 'Hiện vật',

    RecordReceiptExpense: 'Ghi thu - Ghi chi',

    Other: 'Khác',
  },
  /**
   * Kí hiệu âm
   */
  NegativeSign: {
    '(n)': '(n)',
    '-n': '-n',
    '- n': '- n',
    'n-': 'n-',
    'n -': 'n -',
  },
  /**
   * Font chữ
   */
  FontFamily: {
    TimesNewRoman: 'Times New Roman',
    OpenSan: 'Open San',
    Arial: 'Arial',
    Tahoma: 'Tahoma',
    Cambria: 'Cambria',
    ArialNarrow: 'Arial Narrow',
  },
  /**
   * Kiểu chữ
   */
  FontStyle: {
    Regular: 'Regular',
    Bold: 'Bold',
    Italic: 'Italic',
    BoldItalic: 'Bold Italic',
  },
  /**
   *Ghi chú - thiết lập quy tắc hạch toán đồng thời
   */
  SignType: {
    Record: 'Ghi âm',
    Positive: 'Ghi dương',
  },
  /**
   * Tính chất nguồn
   */
  BudgetSourceGroupPropertyType: {
    NotSelected: 'Không chọn',
    Regular: 'Thường xuyên',
    IRegular: 'Không thường xuyên',
  },
  /**
   * Tỉnh/thành phố
   */
  Province: {
    HaNoi: 'Hà Nội',
    HoChiMinh: 'Hồ Chí Minh',
    DaNang: 'Đà Nẵng',
    CanTho: 'Cần Thơ',
  },

  /**
   * Xuất gửi cho
   */
  ExportFor: {
    SendTreasury: 'Xuất khẩu gửi kho bạc nhà nước',
    SendTaxAuthorities: 'Xuất khẩu gửi cơ quan thuế',
  },

  ReportID: {
    // Báo cáo tài chính
    BCTC01: 'BCTC-01',
    BCTC02: 'BCTC-02',
    BCTC03b: 'BCTC-03b',
    BCTC03a: 'BCTC-03a',
    BCTC04: 'BCTC-04',
    BCTC05: 'BCTC-05',
    BCTCExport04: 'BCTCExport-04',
    BCTC01bstt: 'BCTC-01bstt',

    // Báo cáo quyết toán
    BCQT02: 'BCQT-02',
    BCQT03: 'BCQT-03',
  },
  /**
   * Loại công thức
   */
  ColumnDataType: {
    // Hệ số
    Coefficient: 'Hệ số',
    // Tỷ lệ
    Rate: 'Tỷ lệ',
    // Khác
    Other: 'Khác',
  },

  ColumnDataSalaryType: {
    // Hệ số
    Coefficient: 'Hệ số',
    // Tỷ lệ
    Rate: 'Tỷ lệ',
  },
  /**
   *Loại khoản lương
   */
  PayrollItemType: {
    // Thu nhập thường xuyên
    IncomRecurrent: 'Thu nhập thường xuyên',
    // Thu nhập không thường xuyên
    IncomCasual: 'Thu nhập không thường xuyên',
    // Khấu trừ thường xuyên
    OutcomRecurrent: 'Khấu trừ thường xuyên',
    // Khấu trừ không thường xuyên
    OutcomCasual: 'Khấu trừ không thường xuyên',
  },

  /**
   * Hình thức hóa đơn
   */
  PayForm: {
    Cash: 'TM', // Tiền mặt
    Transfer: 'CK', // Chuyển khoản
    Undefined: 'TM/CK', // Chưa xác định được hình thức thanh toán
  },

  /**
   * Mã lỗi Validate
   */
  ValidateCode: {
    Required: 'Nhập thiếu thông tin',
    EditVersion: 'Dữ liệu đã bị thay đổi bởi người dùng khác',
    Duplicate: 'Dữ liệu đã tồn tại trong hệ thống',
    Arise: 'Danh mục đã có phát sinh',
    System: 'Dữ liệu thuộc hệ thống',
  },

  MessageBoxType: {
    confirm_Info_Warning: 0,
    confirm_Yes_No: 1,
    confirm_Yes_No_Cancel: 2,
    confirm_Delete: 3,
    confirm_Close: 4,
  },

  /**
   * RefType danh mục
   * bnanh 04.07.2022
   */
  RefTypeDictionary: {
    CustomerVendor: 1, // Khách hàng, nhà cung cấp
    Employee: 2, // Cán bộ
  },

  /**
   * Enum Ngừng theo dõi
   * NVTUAN1 07.07.2022
   */
  Inactive: {
    All: 'Tất cả',
    Follow: 'Theo dõi',
    Unfollow: 'Ngừng theo dõi',
  },

  /**
   * Enum ghi sổ
   * HQMINH 12.07.2022
   */
  PostedType: {
    All: 'Tất cả',
    NotPosted: 'Chưa ghi sổ',
    Posted: 'Ghi sổ',
  },

  /**
   * Enum Tính thuế
   * TVDAT 12.07.2022
   */
  IsPersonalIncomeTax: {
    All: 'Tất cả',
    IsPersonalIncomeTax: 'Tính thuế',
    NotIsPersonalIncomeTax: 'Không tính thuế',
  },
  /**
   * Enum Tính BHXH
   * TVDAT 12.07.2022
   */
  IsSocialInsurance: {
    All: 'Tất cả',
    IsSocialInsurance: 'Tính BHXH',
    NotIsSocialInsurance: 'Không tính BHXH',
  },
  /**
   * Enum Tính BHYT
   * TVDAT 12.07.2022
   */
  IsHealthInsurance: {
    All: 'Tất cả',
    IsHealthInsurance: 'Tính BHYT',
    NotIsHealthInsurance: 'Không tính BHYT',
  },
  /**
   * Enum Tính BHTN
   * TVDAT 12.07.2022
   */
  IsUnemploymentInsurance: {
    All: 'Tất cả',
    IsUnemploymentInsurance: 'Tính BHTN',
    NotIsUnemploymentInsurance: 'Không tính BHTN',
  },
  /**
   * Enum Tính KPCĐ
   * TVDAT 12.07.2022
   */
  IsLaborUnion: {
    All: 'Tất cả',
    IsLaborUnion: 'Tính KPCĐ',
    NotIsLaborUnion: 'Không tính KPCĐ',
  },
  /**
   * Group ref type
   * NCPHUOC 12/07/2022
   */
  RefTypeGroup: {
    BUPlanReceipt: 'Nhận dự toán',
    BUTransfer: 'Chuyển khoản kho bạc',
  },

  /**
   * Trạng thái validate của dòng nhập khẩu
   * NCPHUOC 28/07/2022
   */
  ImportValidateStatus: {
    Valid: 'Hợp lệ',
    DataExist: 'Dữ liệu đã tồn tại',
    NotValid: 'Không hợp lệ',
  },

  /**
   * Trạng thái hoạt động
   * nddat1 30/01/2023
   */
  ActiveState: {
    All: 'Tất cả',
    Active: 'Sử dụng',
    InActive: 'Ngừng sử dụng',
  },

  /**
   * Công thức chi khác chi dự phòng
   * nmtuan4
   */
  FormulaReserve: {
    RegularInvest: '(Tỷ lệ trích * Chi thường xuyên) + (Tỷ lệ trích * Chi đầu tư phát triển)',
    Regular: 'Tỷ lệ trích * Chi thường xuyên',
    Before: 'Tỷ lệ trích * Dự toán dự phòng năm trước',
    Setting: 'Tự thiết lập',
  },

  /**
   * Công thức
   * tvtoan 30/01/2023
   */
  CalculateReserve: {
    CalculateReserve1: '(Tỷ lệ trích * Chi thường xuyên) + (Tỷ lệ trích * Chi đầu tư phát triển)',
    CalculateReserve2: 'Tỷ lệ trích * Chi thường xuyên',
    CalculateReserve3: 'Tỷ lệ trích * Dự toán dự phòng năm trước',
  },
  /**
   * Công thức
   * tvtoan 30/01/2023
   */
  CalculateSalary: {
    CalculateSalary1: '(1)+(2)+(3)+(4)+(5)+(6)',
  },

  /**
   * Nhóm nhiệm vụ
   * dvthuc 02/02/2024
   */
  RegularGroup: {
    Regular: 'Thường xuyên',
    NotRegular: 'Không thường xuyên',
    AssignedByState: 'Nhiệm vụ nhà nước giao',
  },

  /**
   * Cấp phê duyệt
   * dvthuc 02/02/2024
   */
  GradeApproved: {
    Political: 'Bộ chính trị',
    Congress: 'Quốc hội',
    PrimeMinister: 'Thủ tướng',
    President: 'Chủ tịch nước',
    Government: 'Chính phủ',
    MinisterialLevel: 'Cấp bộ',
    ProvincialPeopleCommittee: 'UBND/HĐND tỉnh',
    GrassrootsLevel: 'Cấp cơ sở',
  },
  TargetGrade: {
    Country: 'Quốc gia',
    Province: 'Tỉnh - Thành phố',
    District: 'Quận - Huyện',
  },
  ActivitiesType: {
    Career: 'Sự nghiệp',
    Service: 'Dịch vụ',
  },
  BusinessType: {
    RevenuePricingGovernment: 'Cung cấp dịch vụ công do nhà nước định giá',
    RevenueOtherServices: 'Hoạt động, dịch vụ khác',
    RevenueOrderOfGovernment: 'Thực hiện đơn đặt hàng của nhà nước',
  },
  ImplementationTrackingBusinessType: {
    All: 'Tất cả',
    RevenuePricingGovernment: 'Cung cấp dịch vụ công do nhà nước định giá',
    RevenueOtherServices: 'Hoạt động, dịch vụ khác',
    RevenueOrderOfGovernment: 'Thực hiện đơn đặt hàng của nhà nước',
  },
  BusinessTypeDetail: {
    Tuition: 'Học phí',
    HospitalsFee: 'Viện phí',
    OtherRevenue: 'Nguồn thu khác',
  },

  SourceStructureType: {
    ExpenseRegular: 'Thu để chi thường xuyên',
    ExpenseInvestXDCB: 'Thu để chi đầu tư XDCB',
  },

  /**
   * Nhóm dự án
   * created by: nnduc 6/2/2024
   */
  ProjectGroup: {
    GroupA: 'Dự án nhóm A',
    GroupB: 'Dự án nhóm B',
    GroupC: 'Dự án nhóm C',
    GroupCountry: 'Dự án quan trọng quốc gia',
  },
  GradeDecision: {
    Congress: 'Quốc hội',
    Secretariat: 'Ban bí thư Trung Ương Đảng',
    PrimeMinister: 'Thủ tướng Chính Phủ',
    Minister: 'Bộ trưởng',
    ProvincialPeopleCommittee: 'UBND/ HĐND Tỉnh',
  },
  /**
   * Cấp ngân sách
   */
  BudgetGrade: {
    Center: 'Ngân sách cấp TW',
    Province: 'Ngân sách cấp Tỉnh',
    District: 'Ngân sách cấp Huyện',
    Ward: 'Ngân sách cấp Xã',
  },
  /**
   * Mode tổng hợp
   */
  BudgetGradeForReport: {
    AllProvince: 'Ngân sách toàn huyện',
    Province: 'Ngân sách Huyện',
    Ward: 'Ngân sách Xã',
  },

  /**
   * Cấp ngân sách của stc
   */
  BudgetTypeSTC: {
    AllProvince: 'Ngân sách toàn tỉnh',
    Province: 'Ngân sách cấp tỉnh',
    District: 'Ngân sách huyện',
  },
  /**
   * Mode tổng hợp
   */
  BudgetGradeForReportSTC: {
    AllProvince: 'Ngân sách toàn tỉnh',
    Province: 'Ngân sách cấp tỉnh',
    District: 'Ngân sách huyện',
  },
  /**
   * loại ctmt, dự án
   * dvhung2 20/02/2024
   */
  ProjectType: {
    Target: 'Chương trình mục tiêu',
    Project: 'Dự án',
  },
  /**
   * loại ctmt, dự án
   * ntchuyen 25.11.2024
   */
  ExpenseInvestTypeDictionary: {
    ExpenseInvest: 'Dự án',
    ExpenseInvestTask: 'Nhiệm vụ',
  },
  /**
   * CTMT, dự án cấp
   * dvhung2 20/02/2024
   */
  ProjectGrade: {
    Country: 'Quốc gia',
    Province: 'Tỉnh - Thành phố',
    District: 'Quận - Huyện',
  },
  RevenueAgencyLevel: {
    Center: 'Cơ quan thu cấp Trung ương',

    Province: 'Cơ quan thu cấp Tỉnh',

    District: 'Cơ quan thu cấp Huyện',

    Wards: 'Cơ quan thu cấp Xã',
  },

  /**
   * Nguyên nhân xóa không thành công
   * nddat1 26/02/2024
   */
  DeleteFailReason: {
    Arise: 'Nội dung đã phát sinh dự toán',
    Enact: 'Nội dung đã ban hành cho đơn vị cấp dưới',
  },

  /**
   * Loại mục - tiểu mục
   * ltviet 29/02/2024
   */
  SectionType: {
    Revenue: 'Tiểu mục thu',
    Expense: 'Tiểu mục chi',
  },

  /**
   * Kiểu dữ liệu của thuyết minh
   * ltviet 05/03/2024
   */
  ExplanModeDataType: {
    Amount: 'Số tiền',
    Text: 'Chữ',
    Date: 'Ngày tháng',
    Boolean: 'Đúng sai',
    Number: 'Số',
    Percent: 'Tỷ lệ',
    List: 'Danh sách',
    Constant: 'Hệ số',
  },

  /**
   * fomatter
   * tvtam  16/04/2024
   */
  ExplanModeFormatter: {
    Number: '#,##0',
    Percent: '0.00%',
    Date: 'dd/mm/yyyy',
    Constant: '#,##0.00',
    Text: '@',
  },
  /**
   * Kiểu dữ liệu của thuyết minh
   * tvtam 08/03/2024
   * 5-Số tiền, 10-Chữ, 15-Ngày tháng, 20-Đúng sai, 25-Số, 30-Tỷ lệ, 35-Danh sách',
   */
  ExplanModeDataTypeNumber: {
    Amount: 5,
    Text: 10,
    Date: 15,
    Boolean: 20,
    Number: 25,
    Percent: 30,
    List: 35,
    Constant: 40,
  },
  /**
   * Kiểu dữ liệu của thuyết minh
   * tvtam 11/03/2024
   *  Kiểu nhập giá trị ngầm định: 5-Nhập giá trị cố định, 10-Nhập giá trị theo điều kiện,15-Nhập giá trị theo công thức
   */
  DefaultTypeNumber: {
    FixedValue: 5,
    ValueToCondition: 10,
    ValueToFormula: 15,
  },
  typeConditionFilterEstimates: {
    Equals: 5, // bằng
  },
  /**
   * Loại điều kiện
   * ltviet 05/03/2024
   */
  ConditionType: {
    Equal: 'Bằng',
    Contain: 'Chứa',
    StartWith: 'Bắt đầu bằng',
    EndWith: 'Kết thúc bằng',
  },

  /**
   * Cân đối/BSMT
   * nddat1 12/03/2024
   */
  ExpenditurePurposeType: {
    Balance: 'Cân đối',
    AddTarget: 'Bổ sung mục tiêu',
  },
  /**
   * Enum Theo dõi
   * dmha 12.03.2024
   */
  OrgStatusEnact: {
    NotSet: 'Chưa thiết lập',
    IsSetting: 'Đang thiết lập',
    AwaitEnact: 'Chờ ban hành',
    Enacted: 'Đã ban hành',
  },
  /**
   * Enum Theo dõi
   * dmha 12.03.2024
   */
  StatusEnactDetail: {
    All: 'Tất cả',
    AddNew: 'Thêm mới',
    Edited: 'Đã sửa',
    Enacted: 'Đã ban hành',
  },
  ModeSync: {
    Add: 'Thêm mới',
    Update: 'Cập nhật',
  },
  /**
   * Enum trạng thái ban hành
   * nnduc 1.04.2024
   */
  StatusSyncDictionary: {
    All: 'Tất cả',
    AddNew: 'Thêm mới',
    Updated: 'Cập nhật',
    Enacted: 'Đã ban hành',
    Deleted: 'Đã xóa',
    Cancel: 'Hủy ban hành',
  },
  /**
   * Enum Cơ cấu
   * nmtuan4 14.03.2024
   */
  StructureType: {
    Invest: 'Đầu tư',
    Regular: 'Thường xuyên',
  },
  /**
   * Enum cân đối, bsmt
   * nmtuan4 14.03.2024
   */
  PurposeType: {
    Symmetrical: 'Chi cân đối ngân sách',
    Target: 'Chi từ nguồn bổ sung có mục tiêu',
  },

  /**
   * Enum công thức thuyết minh lập dự toán chi khác
   */
  ExplanFormulaExpenseOther: {
    RegularInvest: '(Tỷ lệ trích * Chi thường xuyên) + (Tỷ lệ trích * Chi đầu tư)',
    Regular: 'Tỷ lệ trích * Chi thường xuyên',
    Before: 'Tỷ lệ trích * Dự toán dự phòng năm trước',
    Setting: 'Tự thiết lập',
  },

  /**
   * Enum công thức thuyết minh của chi
   * pttam2 08.04.2024
   */
  ExpenseOtherFomulaExplantion: {
    ExpenseOtherCCTL: 'Sum(1)+(2)+(3)+(4)+(5)+(6)',
  },
  /**
   * Enum loại dữ liệu của chi thường xuyên
   * Loại dữ liệu: 5-Lĩnh vực, 10-Chương, 15-Khoản, 20-Nguồn, 25-Tiêu chí thống kê, 30-Nhiệm vụ
   * nddat1 15.03.2024
   */
  DataTypeRegular: {
    Kind: '5',
    Chapter: '10',
    SubKind: '15',
    Source: '20',
    Criteria: '25',
    Regular: '30',
  },
  /**
   * active
   */
  ActiveType: {
    Active: 1,
    InActive: 0,
  },
  /**
   * field active
   */
  FieldActive: {
    Active: 'is_active',
  },

  /**
   * Cấp phê duyệt
   * ltviet 19/03/2024
   */
  GradeApprovedRegular: {
    Political: 'Bộ chính trị',
    Congress: 'Quốc hội',
    PrimeMinister: 'Thủ tướng',
    President: 'Chủ tịch nước',
    Government: 'Chính phủ',
    MinisterialLevel: 'Cấp bộ',
    ProvincialPeopleCommittee: 'UBND/HĐND tỉnh',
  },
  /**
   * Đơn vị tính
   */
  UnitMoney: {
    One: 'Đồng',
    Thousand: 'Nghìn đồng',
    Million: 'Triệu đồng',
    Billion: 'Tỷ đồng',
  },
  /**
   * Đơn vị tính - kèm text
   */
  UnitMoneyWithText: {
    One: 'ĐVT: Đồng',
    Thousand: 'ĐVT: Nghìn đồng',
    Million: 'ĐVT: Triệu đồng',
    Billion: 'ĐVT: Tỷ đồng',
  },

  /**
   * Đơn vị tính đến triệu đồng
   */
  UnitMoneyToMillion: {
    One: 'Đồng',
    Thousand: 'Nghìn đồng',
    Million: 'Triệu đồng',
  },

  /**
   * Phân khai dự toán
   */
  TypeBreakAllocation: {
    None: 'Không phân khai',
    Quater: 'Phân khai dự toán theo quý',
    Month: 'Phân khai dự toán theo tháng',
  },

  /**
   * Loại tổng hợp in báo cáo
   */
  ReportSummaryType: {
    DistrictAndCommune: 'Ngân sách toàn huyện',
    District: 'Ngân sách Huyện',
    Commune: 'Ngân sách Xã',
  },
  /**
   * Error code delete Enact
   */
  EnactDeleteReasonArise: {
    Arise: 'Nội dung nằm trong Mẫu lập dự toán chi thường xuyên',
  },
  /**
   * Enum kiểu dữ liệu của trường
   * TMNghia 16/08/2024
   */
  ExplanationFormModelDataType: [
    {
      TypeId: 10,
      TypeCode: 'Text',
      TypeName: 'Chữ',
    },
    {
      TypeId: 35,
      TypeCode: 'List',
      TypeName: 'Danh sách',
    },
    {
      TypeId: 25,
      TypeCode: 'Number',
      TypeName: 'Số',
    },
    {
      TypeId: 5,
      TypeCode: 'Currency',
      TypeName: 'Số tiền',
    },
    {
      TypeId: 30,
      TypeCode: 'Ratio',
      TypeName: 'Tỷ lệ',
    },
    {
      TypeId: 15,
      TypeCode: 'Date',
      TypeName: 'Ngày tháng',
    },
    {
      TypeId: 20,
      TypeCode: 'Boolean',
      TypeName: 'Đúng/Sai',
    },
  ],

  /**
   * Kiểu lỗi của formula
   * TMNghia 18/03/2024
   */
  FormulaErrorType: {
    InvalidField: 1,
    InvalidOperator: 2,
  },

  /**
   * Kiểu lỗi của formula
   * TMNghia 18/03/2024
   */
  ModelReferenceType: {
    Conditions: 1,
    Formula: 2,
    Filter: 3,
  },
  /**
   * Thông báo lỗi công thức
   * TMNghia 20/03/2024
   */
  FormulaMessageCheck: {
    Valid: 'Công thức hợp lệ',
    InValid: 'Công thức không hợp lệ',
  },

  /**
   * Loại hình đơn vị
   * BQDIEP 21/03/2024
   * Giá trị phân biệt thông tin các đơn vị / 1:Đơn vị STC - 2:Đơn vị PTC - 3:Đơn vị cấp xã - 4:Đơn vị trực thuộc SN - 5:Đơn vị Chủ quản SN
   */
  OrganizationPackCodeType: {
    STC: 1,
    PTC: 2,
    Ward: 3,
    HCSN: 4,
    DVCQSN: 5,
  },

  ComboboxTypeEstimate: {
    REVENUE: [{ name: 'Tổng hợp', value: 0, detail: false, isMerge: true }],
    EXPENSE: [
      { name: 'Tách CTMT - Tổng hợp', value: 0, detail: false, isMerge: true },
      { name: 'Không tách CTMT - Tổng hợp', value: 1, detail: false, isMerge: false },
    ],
    SYMMETRIC: [
      { name: 'Tách CTMT - Tổng hợp', value: 0, isMerge: true, detail: false },
      { name: 'Không tách CTMT - Tổng hợp', value: 1, isMerge: false, detail: false },
    ],
  },

  /** Combobox màn STC kiểm tra PTC dự toán nhu cầu */
  ComboboxTypeEstimateExaminePTC: {
    REVENUE: [
      { name: 'Tổng hợp', value: 0, detail: false, isMerge: true },
      //{ name: 'Chi tiết', value: 1, detail: true, isMerge: true },
    ],
    EXPENSE: [
      {
        name: 'Tách CTMT - DT Tổng hợp',
        value: 0,
        detail: false,
        isMerge: true,
        title: 'Tách Chương trình mục tiêu - Dự án năm hiện hành tổng hợp',
      },
      {
        name: 'Không tách CTMT - DT Tổng hợp',
        value: 1,
        detail: false,
        isMerge: false,
        title: 'Không tách Chương trình mục tiêu - Dự án năm hiện hành tổng hợp',
      },
    ],
    SYMMETRIC: [
      {
        name: 'Tách CTMT - DT Tổng hợp',
        value: 0,
        isMerge: true,
        detail: false,
        title: 'Tách Chương trình mục tiêu - Dự án năm hiện hành tổng hợp',
      },
      {
        name: 'Không tách CTMT - DT Tổng hợp',
        value: 1,
        isMerge: false,
        detail: false,
        title: 'Không tách Chương trình mục tiêu - Dự án năm hiện hành tổng hợp',
      },
    ],
  },

  TitleEstimate: {
    REVENUE: { title: 'Thu', value: 'REVENUE', classes: 'estimate-revenue-ward' },
    EXPENSE: { title: 'Chi', value: 'EXPENSE', classes: 'estimate-expense-ward' },
    SYMMETRIC: { title: 'Cân đối', value: 'SYMMETRIC', classes: 'estimate-symmetric' },
  },
  LayoutEstimateCombine: {
    REVENUE: 'estimateSummaryWardRevenue',
    EXPENSE: 'estimateSummaryWardExpense',
    SYMMETRIC: 'estimateSummaryWardSymmetrical',
  },
  LayoutEstimateSubmit: {
    REVENUE: 'estimateSubmitRevenue',
    EXPENSE: 'estimateSubmitExpense',
    SYMMETRIC: 'estimateSubmitSymmetric',
    SUMMARY: 'estimateSubmitHCSN',
    DETAIL: 'estimateExpenseDetailSubmitHCSN',
  },
  /**
   * PTTAM2-layout dự toán nộp phần lập và cân đối
   */
  LayoutEstimateSubmitArrgrate: {
    REVENUE: 'estimateArrgrateSubmitRevenue',
    EXPENSE: 'estimateArrgrateSubmitExpense',
    SYMMETRIC: 'estimateArrgrateSubmitSymmetric',
  },
  LayoutEstimateSubmitSectorWide: {
    SUMMARY: 'estimateSubmitSectorWide',
    DETAIL: 'estimateExpenseDetailSubmitSectorWide',
    SECTION: 'estimateSectionDetailSubmitSectorWide',
  },
  LayoutEstimateReturn: {
    REVENUE: 'estimateReturnRevenue',
    EXPENSE: 'estimateReturnExpense',
    SYMMETRIC: 'estimateReturnSymmetric',
    SUMMARY: 'estimateReturnHCSN',
    DETAIL: 'estimateExpenseDetailReturnHCSN',
  },
  LayoutExamineFormDetail: {
    REVENUE: 'examineFormRevenue',
    EXPENSE: 'examineFormExpense',
    SYMMETRIC: 'examineFormSymmetric',
    HCSN: 'examineFormSymmetricHCSN',
  },
  EnumMoneyUnit: [
    { name: 'Đồng', value: 0 },
    { name: 'Nghìn đồng', value: 1 },
    { name: 'Triệu đồng', value: 2 },
    { name: 'Tỷ đồng', value: 3 },
  ],

  /**
   * Enum loại chi
   * nddung2 16.03.2024
   * 1-Chi trích tạo nguồn cải cách tiền lương, 2-Chi đầu tư, 3-Chi thường xuyền
   */
  ExpenseType: {
    ExpenseForSalaryReform: 1,
    ExpenseInvest: 2,
    ExpenseRegular: 3,
  },

  /**
   * Trạng thái kiểm tra
   * nddat1 22/03/2024
   */
  ExamineState: {
    Total: 'Tổng số đơn vị',
    NotSubmit: 'Chưa nộp dự toán',
    NotExamine: 'Cần kiểm tra',
    Return: 'Đã gửi trả',
    Complete: 'Đã hoàn thành',
  },
  ExamineSendStatus: {
    /**
     * Chưa nộp
     */
    NotSent: 'Chưa nộp',
    /**
     * Chưa kiểm tra
     */
    NotCheck: 'Chưa kiểm tra',
    /**
     * Đã nộp/ Đang kiểm tra
     */
    Checking: 'Đang kiểm tra',
    /**
     * Đã gửi trả
     */
    Return: 'Đã gửi trả',
    /**
     * Đã hoàn thành
     */
    Complete: 'Đã hoàn thành',
    /**
     * Cấp dưới yêu cầu thu hồi
     */
    RequestRevoke: 'Cấp dưới yêu cầu thu hồi',

    /**
     * đang xử lý gửi trả
     */
    ProcessReturn: 'Đang gửi trả',
    /**
     * xử lý thất bại
     */
    ProcessComplete: 'Đang hoàn thành',

    FailReturn: 'Gửi trả lỗi',
    FailComplete: 'Hoàn thành lỗi',
  },

  /**
   * Enum trạng thái nộp dự toán lên cấp trên
   * PTTAM2 04/02/2023
   */
  SubmitEstimateStatus: {
    /**
     * Chờ duyệt
     */
    Waiting: 'Chờ kiểm tra',
    /**
     * Gửi trả
     */
    Reject: 'Cần sửa',
    /**
     * Đã kiểm tra
     */
    Complete: 'Đã kiểm tra',
    /**
     * Đã gửi trả
     */
    NotSubmit: 'Chưa nộp',

    Processing: 'Đang xử lý',
    Fail: 'Nộp thất bại',
  },
  /**
   * Enum trạng thái nộp dự toán lên cấp trên
   * NXHinh 18.09.2024
   */
  SubmitSummaryStatus: {
    /**
     * Chờ duyệt
     */
    Waiting: 'Chờ kiểm tra',
    /**
     * Gửi trả
     */
    Reject: 'Cần sửa',
    /**
     * Đã kiểm tra
     */
    Complete: 'Đã kiểm tra',
    /**
     * Đã gửi trả
     */
    NotSubmit: 'Chưa nộp',
  },
  /**
   * Enum trạng thái biên bản kiểm tra
   * PTTAM2 04/02/2023
   */
  SubmitEstimateRejectStatus: {
    /**
     * Có biên bản kiểm tra
     */
    HaveAudit: 1,
    /**
     * Không có biên bản kiểm tra
     */
    NotAudit: 0,
  },
  /**
   * Enum Loại nghiệp vụ 1: Lập dự toán nhu cầu
   * NHCUONG 23.03.2024
   */
  EstimateCategoryType: {
    /// Lập dự toán nhu cầu

    BeginYear: 1,

    /**
     * Lập và cân đối theo
     */
    BeginYearArrgrate: 2,

    /**
     * Lập dự toán toàn ngành
     */
    SectorWideBudgetEstimate: 3,
  },

  /**
   * Enum các loại lỗi khi thêm lĩnh vực/ chương
   * nxhinh 28.03.2024
   */
  PatternRegularInvalidType: {
    DuplicateStructure: 'Trùng cấu trúc',
    OnlyAddParent: 'Chỉ thêm mẫu tổng hợp',
  },
  /**
   * Thiết lập nguồn dữ liệu cho đơn vị trực thuộc
   */
  OrganizationChildSourceType: {
    BudgetDecision: 'Quyết định giao dự toán',
    AuditRecord: 'Biên bản kiểm tra dự toán',
  },
  OrganizationType: {
    None: '',
    /**
     * Đơn vị hành chính được giao tự chủ kinh phí
     */
    BudgetIndependentPublicAgency: 'Đơn vị hành chính được giao tự chủ kinh phí',
    /**
     * Đơn vị hành chính không được giao tự chủ kinh tế
     */
    NoneBudgetIndependentPublicAgency: 'Đơn vị hành chính không được giao tự chủ kinh phí',
    /**
     * Đơn vị SNCL tự đảm bảo một phần chi thường xuyên
     */
    SemiAutonomousSNCLPublicAgency: 'Đơn vị SNCL tự bảo đảm một phần chi thường xuyên',
    /**
     * Đơn vị SNCL tự đảm bảo chi thường xuyên và chi đầu tư
     */
    SelfSNCLGoverningEntityWithFullFinancialAutonomy: 'Đơn vị SNCL tự bảo đảm chi thường xuyên và chi đầu tư',
    /**
     * Đơn vị SNCL đảm bảm chi thường xuyên
     */
    AutonomousSNCLPublicAgency: 'Đơn vị SNCL tự bảo đảm chi thường xuyên',
    /**
     * Đơn vị SNCL do Nhà nước đảm bảo chi thường xuyên
     */
    GovernmentFundedSNCLPublicEntity: 'Đơn vị SNCL do Nhà nước bảo đảm chi thường xuyên',
    /**
     * Đơn vị khác
     */
    Other: 'Các đơn vị khác',
  },
  UsingStatus: {
    NotUse: 'Không dùng phần mềm',
    Use: 'Dùng phần mềm',
  },
  NeedsExamineStatus: {
    NotCheck: 'Chưa kiểm tra',
    Checking: 'Đang kiểm tra',
    RequestRevoke: 'Cấp dưới yêu cầu thu hồi',
    /**
     * đang xử lý gửi trả
     */
    ProcessReturn: 'Đang xử lý gửi trả',
    /**
     * xử lý thất bại
     */
    ProcessComplete: 'Đang xử lý hoàn thành',

    FailReturn: 'Gửi trả lỗi',
    FailComplete: 'Hoàn thành lỗi',
  },
  ExamineStatus: {
    /**
     * xử lý thất bại
     */
    Complete: 'Đã hoàn thành',

    ProcessCancelComplete: 'Đang hủy hoàn thành',
    FailCancelComplete: 'Hủy hoàn thành lỗi',
  },
  /**
   * Enum các loại nguồn
   * vcdoan 29.03.2024
   */
  SourceType: {
    Sources: 'NGUỒN NGÂN SÁCH NHÀ NƯỚC',
    Activities: 'NGUỒN HOẠT ĐỘNG SỰ NGHIỆP, DỊCH VỤ',
    Fees: 'NGUỒN PHÍ LỆ PHÍ',
    SalaryReform: 'NGUỒN THỰC HIỆN CẢI CÁCH TIỀN LƯƠNG',
  },
  /**
   * Message validate
   */
  InvalidCellMessage: {
    Required: 'không được để trống.',
    Format: 'không đúng định dạng.',
  },
  /**
   * Kiểu dữ liệu trường thuyết minh
   */
  ModelDataType: {
    Text: 10,
    List: 35,
    Number: 25,
    Currency: 5,
    Ratio: 30,
    Constant: 40,
    Date: 15,
    Boolean: 20,
  },

  /**
   *
   */
  TitleEstimateHcsn: {
    SUMMARY: { title: 'Tổng hợp', value: 'SUMMARY', classes: 'estimate-summary-hcsn' },
    DETAIL: { title: 'Chi tiết', value: 'DETAIL', classes: 'estimate-detail-hcsn' },
  },
  /**
   * Mode xem nộp dự toán tại lập và cân đối
   * PTTAM2
   */
  TitleSubmitEstimateArrgrate: {
    Revenue: { title: 'Thu', value: 'REVENUE' },
    Expense: { title: 'Chi', value: 'EXPENSE' },
    Symmetric: { title: 'Cân đối', value: 'SYMMETRIC' },
  },
  ComboboxTypeSubmitEstimateArrgrate: {
    REVENUE: [
      { name: 'Tổng hợp', value: 0, detail: false, isSummary: false },
      // {name: 'Chi Tiết', value: 1, detail: false, isSummary: true},
    ],
    EXPENSE: [
      { name: 'Tách CTMT - DT tổng hợp', value: 0, isSummary: false, detail: false },
      { name: 'Không tách CTMT - DT tổng hợp', value: 1, isSummary: true, detail: false },
    ],
    SYMMETRIC: [
      { name: 'Tách CTMT - DT tổng hợp', value: 0, isSummary: false, detail: false },
      { name: 'Không tách CTMT - DT tổng hợp', value: 1, isSummary: true, detail: false },
    ],
  },
  /**
   * Mode xem nộp dự toán tại lập dự toán toàn ngành
   * PTTAM2
   */
  TitleSubmitEstimateSectorWide: {
    SUMMARY: { title: 'Tổng hợp', value: 'SUMMARY' },
    DETAIL: { title: 'Chi tiết', value: 'DETAIL' },
  },
  /**
   *
   */
  TitleEstimateDVCQ: {
    SUMMARY: { title: 'Tổng hợp', value: 'SUMMARY' },
    DETAIL: { title: 'Chi tiết', value: 'DETAIL' },
  },

  /**
   * Mode xem tổng hợp
   * vcdoan
   */
  TitleSummaryMode: {
    Summary: { title: 'Tổng hợp', value: 'SUMMARY' },
    Detail: { title: 'Chi tiết', value: 'DETAIL' },
  },

  TitleSummaryModeWard: {
    Revenue: { title: 'Thu', value: 'REVENUE' },
    Expense: { title: 'Chi', value: 'EXPENSE' },
    Balance: { title: 'Cân đối', value: 'BALANCE' },
  },

  TitleSummaryModeDistrictSTC: {
    Revenue: { title: 'Thu', value: 'REVENUE' },
    Expense: { title: 'Chi', value: 'EXPENSE' },
    Balance: { title: 'Cân đối', value: 'BALANCE' },
  },

  TitleSummaryModePTC: {
    Revenue: { title: 'Thu', value: 'REVENUE' },
    Expense: { title: 'Chi', value: 'EXPENSE' },
    Balance: { title: 'Cân đối', value: 'BALANCE' },
  },

  TitleSummaryModeSTC: {
    Revenue: { title: 'Thu', value: 'REVENUE' },
    Expense: { title: 'Chi', value: 'EXPENSE' },
    Balance: { title: 'Cân đối', value: 'BALANCE' },
  },

  ComboboxTypeSummaryWard: {
    REVENUE: [
      { name: 'Tổng hợp', value: 0, detail: false, isSummary: false },
      // {name: 'Chi Tiết', value: 1, detail: false, isSummary: true},
    ],
    EXPENSE: [
      { name: 'Tách CTMT - DT tổng hợp', value: 0, isSummary: false, detail: false },
      { name: 'Không tách CTMT - DT tổng hợp', value: 1, isSummary: true, detail: false },
    ],
    BALANCE: [
      { name: 'Tách CTMT - DT tổng hợp', value: 0, isSummary: false, detail: false },
      { name: 'Không tách CTMT - DT tổng hợp', value: 1, isSummary: true, detail: false },
    ],
  },

  ComboboxTypeSummaryDistrictSTC: {
    REVENUE: [
      { name: 'Tổng hợp', value: 0, detail: false, isSummary: false },
      // {name: 'Chi Tiết', value: 1, detail: false, isSummary: true},
    ],
    EXPENSE: [
      { name: 'Tách CTMT - DT tổng hợp', value: 0, isSummary: false, detail: false },
      { name: 'Không tách CTMT - DT tổng hợp', value: 1, isSummary: true, detail: false },
    ],
    BALANCE: [
      { name: 'Tách CTMT - DT tổng hợp', value: 0, isSummary: false, detail: false },
      { name: 'Không tách CTMT - DT tổng hợp', value: 1, isSummary: true, detail: false },
    ],
  },

  ComboboxTypeSummaryPTC: {
    REVENUE: [
      { name: 'Tổng hợp', value: 0, detail: 0, isSummary: 0 },
      // {name: 'Chi Tiết', value: 1, detail: false, isSummary: true},
    ],
    EXPENSE: [
      { name: 'Tách CTMT - DT tổng hợp', value: 0, isSummary: 0, detail: 0 },
      { name: 'Không tách CTMT - DT tổng hợp', value: 1, isSummary: 1, detail: 0 },
    ],
    BALANCE: [
      { name: 'Tách CTMT - DT tổng hợp', value: 0, isSummary: 0, detail: 0 },
      { name: 'Không tách CTMT - DT tổng hợp', value: 1, isSummary: 1, detail: 0 },
    ],
  },

  ComboboxAllocationTrackingByField: [
    { name: 'Tất cả', value: 1 },
    { name: 'Cân đối ngân sách địa phương', value: 2 },
    { name: 'Bổ sung có mục tiêu từ NSTW', value: 3 },
  ],
  ComboboxAllocationTrackingByFieldPTC: [
    { name: 'Tất cả', value: 1 },
    { name: 'Cân đối ngân sách địa phương', value: 2 },
    { name: 'Bổ sung có mục tiêu từ NS Tỉnh', value: 3 },
  ],
  ComboboxOrgOptionSummarySymmetrical: [
    { name: 'Cân đối ngân sách toàn Huyện', value: 2 },
    { name: 'Cân đối ngân sách Huyện', value: 1 },
    { name: 'Cân đối ngân sách Xã', value: 0 },
  ],

  ComboboxOrgOptionSummarySymmetricalSTC: [
    { name: 'Cân đối ngân sách toàn Tỉnh', value: 4 },
    { name: 'Cân đối ngân sách Tỉnh', value: 3 },
    { name: 'Cân đối ngân sách Huyện', value: 1 },
  ],

  ComboboxOrgOptionSubmitSymmetricalSTC: [
    { name: 'Cân đối ngân sách toàn Tỉnh', value: 4 },
    { name: 'Cân đối ngân sách Tỉnh', value: 3 },
    { name: 'Cân đối ngân sách Huyện', value: 1 },
  ],

  ComboboxOrgOptionExamineSymmetrical: [
    { name: 'Ngân sách toàn Huyện', value: 2 },
    { name: 'Ngân sách Huyện', value: 1 },
    { name: 'Ngân sách Xã', value: 0 },
  ],

  SummaryOptions: {
    Ward: 'Ngân sách cấp xã',
    District: 'Ngân sách cấp huyện',
    AllDistrict: 'Ngân sách toàn huyện',
  },
  SummaryOptionsPTC: {
    Ward: 'Ngân sách Xã',
    District: 'Ngân sách Huyện',
    AllDistrict: 'Ngân sách toàn huyện',
  },

  SummaryOptionsInSTC: {
    District: 'Ngân sách huyện',
    Province: 'Ngân sách cấp tỉnh',
    AllProvince: 'Ngân sách toàn tỉnh',
  },

  SummaryOptionsSTC: {
    District: 'Ngân sách Huyện',
    Province: 'Ngân sách cấp tỉnh',
    AllProvince: 'Ngân sách toàn tỉnh',
  },

  ComboboxTypeSummaryDistrict: {
    SUMMARY: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, detail: false, isSummary: false },
      { name: 'Tách CTMT - DT chi tiết', value: 0, isSummary: false, detail: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 1, detail: false, isSummary: true },
      { name: 'Không tách CTMT - DT chi tiết', value: 1, isSummary: true, detail: false },
    ],
    DETAIL: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, detail: false, isSummary: false },
      //{name: 'Tách CTMT - DT chi tiết', value: 0, isSummary: false, detail: false},
      { name: 'Không tách CTMT - DT Tổng hợp', value: 1, detail: false, isSummary: true },
      //{name: 'Không tách CTMT - DT chi tiết', value: 1, isSummary: true, detail: false},
    ],
  },

  ComboboxTypeSummaryProvineSTC: {
    SUMMARY: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, detail: false, isSummary: false },
      { name: 'Tách CTMT - DT chi tiết', value: 0, isSummary: false, detail: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 1, detail: false, isSummary: true },
      { name: 'Không tách CTMT - DT chi tiết', value: 1, isSummary: true, detail: false },
    ],
    DETAIL: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, detail: false, isSummary: false },
      //{name: 'Tách CTMT - DT chi tiết', value: 0, isSummary: false, detail: false},
      { name: 'Không tách CTMT - DT Tổng hợp', value: 1, detail: false, isSummary: true },
      { name: 'Tổng hợp chi thường xuyên', value: 2, isSummary: 'SummaryRegular', detail: true },
    ],
  },

  /**
   * Combobox tại đơn vị Hcsn
   */
  ComboboxTypeEstimateHcsn: {
    SUMMARY: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, detail: false, isMerge: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 1, detail: false, isMerge: true },
    ],
    DETAIL: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 1, isMerge: true, detail: false },
    ],
  },
  /**
   * Combobox tại đơn vị Hcsn có mục, tiểu mục
   */
  ComboboxTypeEstimateHcsnSubsection: {
    SUMMARY: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, detail: false, isMerge: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 1, detail: false, isMerge: true },
    ],
    DETAIL: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 1, isMerge: true, detail: false },
      { name: 'Chi tiết Mục, tiểu mục - DT Tổng hợp', value: 2, isMerge: 'DetailSubsection', detail: false },
    ],
  },

  /**
   * Combobox tại đơn vị Hcsn dự toán đầu năm
   */
  ComboboxTypeEstimateHcsnInitial: {
    SUMMARY: [
      { name: 'Tách CTMT', value: 0, detail: false, isMerge: false },
      { name: 'Không tách CTMT', value: 1, detail: false, isMerge: true },
    ],
    DETAIL: [
      { name: 'Tách CTMT', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT', value: 1, isMerge: true, detail: false },
    ],
  },
  /**
   * Combobox tại đơn vị Hcsn thêm chi tiết theo mục tiểu mục
   */
  ComboboxTypeSummaryEstimateHcsn: {
    SUMMARY: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, detail: false, isMerge: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 1, detail: false, isMerge: true },
    ],
    DETAIL: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 1, isMerge: true, detail: false },
      { name: 'Chi tiết Mục, tiểu mục - DT Tổng hợp', value: 2, isMerge: 'DetailSubsection', detail: false },
    ],
  },
  ComboboxTypeEstimateCqsn: {
    SUMMARY: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, detail: false, isMerge: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 1, detail: false, isMerge: true },
    ],
    DETAIL: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 1, isMerge: true, detail: false },
      { name: 'Chi tiết Mục, tiểu mục - DT tổng hợp', value: 2, isMerge: 2, detail: false },
    ],
  },
  ComboboxTypeExamineCqsn: {
    Expense: [{ name: 'Tổng hợp', value: 0, detail: false, isSummary: false }],
  },
  ComboboxTypeSummaryEstimateInitialCqsn: {
    SUMMARY: [
      { name: 'Tách CTMT', value: 0, detail: false, isMerge: false },
      { name: 'Không tách CTMT', value: 1, detail: false, isMerge: true },
    ],
    DETAIL: [
      { name: 'Tách CTMT', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT', value: 1, isMerge: true, detail: false },
    ],
  },
  /**
   * Combo tổng hợp dự toán sau lập
   */

  ComboboxTypeEstimateArrgrateSectorWide: {
    SUMMARY: [
      { name: 'Tách CTMT - DT tổng hợp', value: 0, detail: false, isSummary: false, isMerge: true },
      { name: 'Không tách CTMT - DT tổng hợp', value: 1, detail: false, isSummary: true, isMerge: false },
    ],
    DETAIL: [
      { name: 'Tách CTMT - DT tổng hợp', value: 0, isMerge: true, detail: false, isSummary: false },
      { name: 'Không tách CTMT - DT tổng hợp', value: 1, isMerge: false, detail: false, isSummary: true },
      {
        name: 'Chi tiết Mục, tiểu mục - DT Tổng hợp',
        value: 0,
        isMerge: 'DetailSubsection',
        detail: false,
        isSummary: false,
      },
    ],
  },
  ComboboxTypeSubmitEstimateVillage: {
    REVENUE: [{ name: 'Tổng hợp', value: 0, isDetail: false, isMerge: true }],
    EXPENSE: [
      {
        name: 'Tách CTMT - Tổng hợp',
        value: 0,
        isDetail: false,
        isMerge: true,
        title: 'Tách Chương trình mục tiêu - Dự toán năm hiện hành tổng hợp',
      },
      {
        name: 'Không tách CTMT - Tổng hợp',
        value: 2,
        isDetail: false,
        isMerge: false,
        title: 'Không tách Chương trình mục tiêu - Dự toán năm hiện hành tổng hợp',
      },
    ],
    SYMMETRIC: [
      {
        name: 'Tách CTMT - Tổng hợp',
        value: 0,
        isMerge: true,
        isDetail: false,
        title: 'Tách Chương trình mục tiêu - Dự toán năm hiện hành tổng hợp',
      },
      {
        name: 'Không tách CTMT - Tổng hợp',
        value: 2,
        isMerge: false,
        isDetail: false,
        title: 'Không tách Chương trình mục tiêu - Dự toán năm hiện hành tổng hợp',
      },
    ],
  },

  ComboboxTypeSubmitEstimateHcsn: {
    SUMMARY: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, detail: false, isMerge: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 2, detail: false, isMerge: true },
    ],
    DETAIL: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 2, isMerge: true, detail: false },
      { name: 'Chi tiết Mục, tiểu mục - DT tổng hợp', value: 4, isMerge: false, detail: false },
    ],
  },
  ComboboxTypeReturnEstimateHcsn: {
    DETAIL: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 2, isMerge: true, detail: false },
    ],
  },
  /**
   * Combo chọn tại lập dự toán toàn ngành
   * PTTAM2
   */
  ComboboxTypeSubmitEstimateSectorWide: {
    SUMMARY: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, detail: false, isMerge: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 2, detail: false, isMerge: true },
    ],
    DETAIL: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 2, isMerge: true, detail: false },
    ],
  },
  /**
   * Combo chọn tại lập dự toán toàn ngành
   * PTTAM2
   */
  ComboboxTypeSubmitEstimateSectorWideCQSN: {
    SUMMARY: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, detail: false, isMerge: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 2, detail: false, isMerge: true },
    ],
    DETAIL: [
      { name: 'Tách CTMT - DT Tổng hợp', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT Tổng hợp', value: 2, isMerge: true, detail: false },
      { name: 'Chi tiết Mục, tiểu mục - DT tổng hợp', value: 4, isMerge: null, detail: false },
    ],
  },
  /**
   * Combo chọn tại tổng hợp phân bổ chi NSNN
   * PTTAM2
   */
  ComboboxTypeAllocationImpStateBudgetExpense: [
    { name: 'Tách CTMT - DT chi tiết', value: 1 },
    { name: 'Tách CTMT - DT tổng hợp', value: 2 },
    { name: 'Không tách CTMT - DT chi tiết', value: 3 },
    { name: 'Không tách CTMT - DT tổng hợp', value: 4 },
  ],
  /**
   * Combo chọn tại tổng hợp phân bổ chi NSNN
   * PTTAM2
   */
  DataValueAllocationImpStateBudgetExpense: {
    SeparateProjectDetail: 1, // tách ctmt chi tiết
    SeparateProjectSummay: 2, // tách ctmt tổng hợp
    NoSeparateProjectDetail: 3, // không tách ctmt chi tiết
    NoSeparateProjectSummay: 4, // không tách ctmt tổng hợp
  },
  /**
   * Combo chọn cấp cân đối màn phân bổ
   * NXHinh 13.12.2024
   * Modified by DTHieu1 : Sửa theo PBI 456496 -> có luồng đang cùng dùng nhưng đã comment code
   */
  ComboboxTypeAllocationImpSummaryBudget: [
    { name: 'Xem theo: Cân đối Tỉnh - Tách CTMT', value: 1 },
    { name: 'Xem theo: Cân đối Tỉnh - Không tách CTMT', value: 5 },
    { name: 'Xem theo: Cân đối Huyện - Tách CTMT', value: 20 },
    { name: 'Xem theo: Cân đối toàn Tỉnh - Không tách CTMT', value: 50 }
  ],

  /**
   * Combo chọn cấp cân đối màn phân bổ
   * ndhieu3 17.12.2024
   */
  ComboboxTypeAllocationImpPtcSummaryBudget: [
    { name: 'Cân đối ngân sách Xã', value: 1 },
    { name: 'Cân đối ngân sách Huyện', value: 2 },
    { name: 'Cân đối ngân sách toàn Huyện', value: 3 },
  ],

  /**
   * Combo chọn view xem cân
   * tvanh 02.01.2025
   */
  ComboboxViewAlcImpPtcSummaryLocalExpense: [
    { name: 'Tách CTMT - Tổng hợp cân đối', value: 1, title: 'Tách Chương trình mục tiêu - Tổng hợp cân đối' },
    {
      name: 'Không tách CTMT - Tổng hợp cân đối',
      value: 2,
      title: 'Không tách Chương trình mục tiêu - Tổng hợp cân đối',
    },
  ],

  /**
   * Layout tại đơn vị Hcsn
   */
  LayoutEstimateCombineHcsn: {
    SUMMARY: 'estimateSummaryHCSN',
    DETAIL: 'estimateExpenseSummaryHcsn',
  },
  LayoutEstimateCombineCqsn: {
    SUMMARY: 'estimateExpenseSummaryCQSN',
    DETAIL: 'estimateExpenseSummaryCQSN',
  },
  LayoutEstimateCombineCqsn: {
    SUMMARY: 'estimateExpenseSummaryCQSN',
    DETAIL: 'estimateExpenseSummaryCQSN',
  },

  LayoutSummaryBeginYearWard: {
    REVENUE: 'estimateSummaryWardRevenue',
    EXPENSE: 'estimateSummaryWardExpensePTC',
    BALANCE: 'summaryEstimateWardSymmetric',
  },

  LayoutSummaryBeginYearDistrictSTC: {
    REVENUE: 'estimateSummaryDistrictRevenueSTC',
    EXPENSE: 'estimateSummaryDistrictExpenseSTC',
    BALANCE: 'estimateSummaryDistrictBalanceSTC',
  },

  LayoutSummaryBeginYearDistrict: {
    SUMMARY: 'estimateSummaryHCSNPTC',
    DETAIL: 'estimateExpenseSummaryDistrict',
    SummaryRegular: 'summaryRegular',
    summaryRegularTest: 'summaryRegularTest',
  },

  LayoutAuditReceiveHcsn: {
    SUMMARY: 'estimateSummaryHCSN',
    DETAIL: 'auditReceiveExpenseHcsn',
  },

  LayoutAuditReceiveDvcq: {
    SUMMARY: 'estimateSummaryDVCQ',
    DETAIL: 'auditReceiveExpenseDVCQ',
  },

  /**Layout màn kiểm tra PTC dự toán nhu cầu */
  LayoutAuditReceivePTC: {
    REVENUE: 'auditReceivePTCRevenue',
    EXPENSE: 'auditReceivePTCExpense',
    SYMMETRIC: 'auditReceivePTCSymmetric',
  },

  /**Layout màn kiểm tra PTC dự toán kiểm tra */
  LayoutAuditEstimatePTC: {
    REVENUE: 'auditEstimateArrgratePTCRevenue',
    EXPENSE: 'auditEstimatePTCExpense',
    SYMMETRIC: 'auditEstimatePTCSymmetric',
  },

  /** Layout cân đối dự toán PTC */
  LayoutSummaryEstimateArrgratePTC: {
    REVENUE: 'summaryEstimateArrgrateRevenue',
    EXPENSE: 'summaryEstimateArrgrateExpense',
    BALANCE: 'summaryEstimatePTCSymmetric',
  },

  /** Layout cân đối dự toán STC */
  LayoutSummaryEstimateArrgrateSTC: {
    REVENUE: 'summaryEstimateArrgrateSTCRevenue',
    EXPENSE: 'summaryEstimateArrgrateExpense',
    BALANCE: 'summaryEstimateSTCSymmetric',
  },

  /** Layout cân đối dự toán STC */
  LayoutSubmitEstimateArrgrateSTC: {
    REVENUE: 'submitEstimateArrgrateSTCRevenue',
    EXPENSE: 'submitEstimateArrgrateSTCExpense',
    SYMMETRIC: 'submitEstimateArrgrateSTCSymmetric',
  },

  /**Layout tổng hợp dữ liệ sau kiểm tra */
  LayoutSummaryEstimateSectorWide: {
    SUMMARY: 'summaryEstimatePTCSymmetric',
    DETAIL: 'summaryEstimatePTCSymmetric',
  },

  /**Layout tổng hợp dữ liệu sau lập lại */
  LayoutSummaryEstimateDVCQSectorWide: {
    SUMMARY: 'summaryEstimateDVCQSymmetric',
    DETAIL: 'summaryEstimateDVCQSymmetricDetail',
  },

  /** Option radio tại cân đối dự toán, đơn vị PTC */
  TitleSummaryModePTC: {
    Revenue: { title: 'Thu', value: 'REVENUE' },
    Expense: { title: 'Chi', value: 'EXPENSE' },
    Balance: { title: 'Cân đối', value: 'BALANCE' },
  },

  /**
   * Combobox tại tại cân đối dự toán, đơn vị PTC
   */
  ComboboxTypeEstimateArrgratePTC: {
    REVENUE: [{ name: 'Tổng hợp', value: 0, detail: false, isMerge: false }],
    EXPENSE: [
      { name: 'Tách CTMT - DT tổng hợp ', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT tổng hợp ', value: 1, isMerge: true, detail: false },
    ],
    BALANCE: [
      { name: 'Tách CTMT - DT tổng hợp', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT tổng hợp', value: 1, isMerge: true, detail: false },
    ],
  },

  /**
   * Combobox tại tại cân đối dự toán, đơn vị Sở tài chính
   */
  ComboboxTypeEstimateArrgrateSTC: {
    REVENUE: [{ name: 'Tổng hợp', value: 0, detail: false, isMerge: false }],
    EXPENSE: [
      { name: 'Tách CTMT - DT tổng hợp ', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT tổng hợp ', value: 1, isMerge: true, detail: false },
    ],
    BALANCE: [
      { name: 'Tách CTMT - DT tổng hợp', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT tổng hợp', value: 1, isMerge: true, detail: false },
      { name: 'Tách CTMT - Chi tiết từng huyện', value: 2, isMerge: false, detail: false },
      { name: 'Không tách CTMT - Chi tiết từng huyện', value: 3, isMerge: true, detail: false },
    ],
    BALANCEPROVINCE: [
      { name: 'Tách CTMT - DT tổng hợp', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT tổng hợp', value: 1, isMerge: true, detail: false },
    ],
  },

  /**
   * Combobox tại tại cân đối dự toán, đơn vị Sở tài chính
   */
  ComboboxTypeSubmitEstimateArrgrateSTC: {
    REVENUE: [{ name: 'Tổng hợp', value: 0, detail: false, isMerge: false }],
    EXPENSE: [
      { name: 'Tách CTMT - DT tổng hợp ', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT tổng hợp ', value: 1, isMerge: true, detail: false },
    ],
    SYMMETRIC: [
      { name: 'Tách CTMT - DT tổng hợp', value: 0, isMerge: false, detail: false },
      { name: 'Không tách CTMT - DT tổng hợp', value: 1, isMerge: true, detail: false },
      { name: 'Tách CTMT - Chi tiết từng huyện', value: 2, isMerge: false, detail: false },
      { name: 'Không tách CTMT - Chi tiết từng huyện', value: 3, isMerge: true, detail: false },
    ],
  },
  /**
   * Layout tại đơn vị Hcsn
   */
  LayoutAuditEstimateCombineHcsn: {
    DETAIL: 'examineFormSymmetricHCSN',
  },

  /**
   * Layout tại đơn vị CQSN
   */
  examineFormSymmetricCQSN: {
    DETAIL: 'examineFormSymmetricCQSN',
  },

  actionToolbar: {
    Undo: 'Undo',
    Redo: 'Redo',
    TextColor: 'TextColor',
    Freeze: 'Freeze',
    UnFreeze: 'UnFreeze',
    WordWrap: 'WordWrap',
    Indent: 'Indent',
    UnIndent: 'UnIndent',
    MergeCell: 'MergeCell',
    LeftAlign: 'LeftAlign',
    CenterAlign: 'CenterAlign',
    RightAlign: 'RightAlign',
    DistributedAlign: 'DistributedAlign',
    TopAlign: 'TopAlign',
    MidAlign: 'MidAlign',
    BottomAlign: 'BottomAlign',
    BorderAll: 'BorderAll',
    IncreaseDecimal: 'IncreaseDecimal',
    DecreaseDecimal: 'DecreaseDecimal',
    FontFamily: 'FontFamily',
    FontSize: 'FontSize',
    Bold: 'Bold',
    Italicized: 'Italic',
    Underlined: 'Underlined',
    BackgroundColor: 'BackgroundColor',
    FontColor: 'FontColor',
    Formatter: 'Formatter',
    ButtonDropdown: 'ButtonDropdown',
    BorderOptions: 'ButtonDropdown',
    Search: 'Search',
  },

  ToolbarItemType: {
    Button: 1,
    Combobox: 2,
    ColorPicker: 3,
    Group: 4,
    ButtonDropdown: 5,
  },

  WorkbookEnum: {
    DefaultColumnWidth: 150,
    DefaultRowHeight: 24,
    DefaultFontSize: 11, //pt
    DefaultRowNumber: 10,
    DefaultBorderColor: '#E0E0E0',
    DefaultSheetName: 'Sheet',
    BorderColor: 'black',
    IsFirstBuildDefaultTemplate: 17,
    IsFirstBuildExplanationForm: 0,
    RowStateEdited: 1,
    RowStateDefault: 0,
    DefaultFontWeight: 'normal',
    DefaultFontStyle: 'normal',
    DefaultFontFamily: 'Times New Roman',
    DefaultBackColor: 'white',
    LockedBackColor: '#f5f5f5',
    LockedBorderColor: 'gray',
    HasDicNames: 'HasDicNames',
  },

  BorderOptions: {
    None: 'none',
    All: 'all',
    Inside: 'inside',
    Outline: 'outline',
    Left: 'left',
    Right: 'right',
    Top: 'top',
    Bottom: 'bottom',
  },
  /**
   * Tab nộp dự toán
   * tvanh 02.04.2024
   */
  SubmitEstimateTab: {
    EstimateTab: 'Dự toán nhu cầu',
    ExamineTab: 'Dự toán kiểm tra',
    EstInitialTab: 'Dự toán đầu năm',
  },
  // trạng thai phê duyệt
  CollectFeeStatus: {
    Add: 'Thêm mới',
    GroupContent: 'Gộp nội dung',
    InjectContent: 'Từ chối',
    WaitApprove: 'Chờ duyệt',
  },
  // đề xuất phê duyệt
  ProposeStatus: {
    Add: 'Thêm mới',
    // Gộp nội dung
    GroupContent: 'Gộp nội dung',
  },
  TooltipShortkey: {
    Esc: 'ESC',
    Add: 'Ctrl + 1',
    Edit: 'Ctrl + E',
    Delete: 'Ctrl + D',
    Save: 'Ctrl + S',
    Refresh: 'Ctrl + R',
    Cancel: 'Ctrl + H',
    Quit: 'Ctrl + Q',
    Help: 'F1',
    Sort: 'Ctrl + /',
    ShowHideColumn: 'Ctrl + *',
    InsertRowGrid: 'Ctrl + Insert',
    DeleteRowGrid: 'Ctrl + Delete',
    Duplicate: 'Ctrl + Shift + C',
  },
  AuditEstimateStatus: {
    /**
     * Đang kiểm tra
     */
    Checking: 'Đang kiểm tra',
    /**
     * Đã hoàn thành
     */
    Complete: 'Đã hoàn thành',

    /**
     * Gửi trả
     */
    Return: 'Gửi trả',
    /**
     * đang xử lý gửi trả
     */
    ProcessReturn: 'Đang gửi trả',
    /**
     * xử lý thất bại
     */
    ProcessComplete: 'Đang hoàn thành',

    FailReturn: 'Gửi trả lỗi',
    FailComplete: 'Hoàn thành lỗi',
  },

  AuditDictionaryStatus: {
    Pending: 'Chờ duyệt',
    Add: 'Thêm mới',
    Refuse: 'Từ chối',
    Merge: 'Gộp nội dung',
  },
  AuditDictionaryPropose: {
    Add: 'Thêm mới',
    Merge: 'Gộp nội dung',
  },

  HasExplanation: {
    NoExplanation: 'Chưa có thuyết minh',
  },

  TenantType: {
    /// Tổng hợp

    Summary: 1,

    /// Lập dự toán

    Estimate: 2,
  },
  TenantTypeName: {
    /// Tổng hợp

    Summary: 'Tổng hợp',

    /// Lập dự toán

    Estimate: 'Lập dự toán',
  },

  /**
   * Index các cột kiểm tra thu phí lệ phí
   * nddat1 23.04.2024
   */
  ExamineRevenueFeeRowIndex: {
    // Dự toán thu
    Revenue: 1,
    // Tỉ lệ nộp NSNN
    Rate: 2,
    // Số nộp NSNN
    Submit: 3,
    // Số được để lại
    Remaining: 4,
  },

  /**
   * Index các cột kiểm tra thu phí lệ phí
   * nddung2 27.05.2025
   */
  ExamineRevenueFeeRowText: {
    // Dự toán thu
    Revenue: "Dự toán thu",
    // Tỉ lệ nộp NSNN
    Rate: "Tỷ lệ nộp NSNN",
    // Số nộp NSNN
    Submit: "Số nộp NSNN",
    // Số được để lại
    Remaining: "Số được để lại",
  },

  FeedbackMode: {
    /// Nhu cầu

    Receive: 'Nhu cầu',

    /// Lập dự toán

    Examine: 'Kiểm tra',
  },
  statusEstimateArrgrate: {
    unCreate: 0,
    unchecked: 1,
    create: 2,
    custom: 3,
  },
  ReportMode: {
    /**
     * Lập dự toán
     */
    Estimate: 1,

    /**
     * Phân bổ
     */
    Allocation: 2,
  },

  /// Mã của trả từ MISA ID

  MISAIDCode: {
    /// Dữ liệu đầu vào thiếu

    InputFailed: 'InputFailed',

    /// Response trả về không có

    ResponseMISAIDFailed: 'ResponseMISAIDFailed',

    /// API trả về null

    ResponseMISAIDApiNull: 'ResponseMISAIDApiNull',
  },

  /**
   * Trạng thái kiểm tra lần nộp
   * nddat1 23.04.2024
   */
  ExamineDemandStatus: {
    /// Chờ duyệt

    Checking: 10,

    /// Đã gửi trả

    Return: 15,

    /// Đã duyệt

    Complete: 20,
  },
  SummaryType: {
    Summary: { key: 5, text: 'Tổng cộng' },
    Average: { key: 10, text: 'Trung bình' },
    // Count: {key: 15, text: 'Đếm'}
  },
  SummaryText: {
    Summary: 'SUM',
    Average: 'AVERAGE',
    Count: 'COUNT',
  },
  SummaryTypeCell: {
    Summary: 5,
    Count: 10,
    Average: 15,
  },
  /**
   * Góp ý
   */
  FeedBack: {
    HasFeedBack: 'Nhiệm vụ đã được góp ý',
  },

  //Trạng thái ban hành của đơn vị
  OrganizationStatusEnact: {
    /// Chưa thiết lập

    NotSet: 1,

    /// Đang thiết lập

    IsSetting: 2,

    /// Chờ ban hành

    AwaitEnact: 3,

    /// Đã ban hành

    Enacted: 4,
  },

  OrganizationReportTypes: [
    { key: 1, name: 'Đơn vị sử dụng ngân sách', display: 'Mẫu dành cho đơn vị sử dụng ngân sách', type: 4 },
    { key: 2, name: 'Xã/Phường', display: 'Mẫu dành cho Xã/Phường', type: 5 },
    { key: 3, name: 'Đơn vị tổng hợp dự toán', display: 'Mẫu tổng hợp dự toán', type: 3 },
    { key: 4, name: 'Phòng Tài chính', display: 'Mẫu tổng hợp toàn Quận/Huyện', type: 2 },
    { key: 5, name: 'Sở Tài chính', display: 'Mẫu tổng hợp toàn Tỉnh/Thành phố', type: 1 },
  ],
  BudgetDistributionType: {
    Central: 'Ngân sách cấp trung ương',
    Province: 'Ngân sách cấp tỉnh',
    District: 'Ngân sách cấp huyện',
    Ward: 'Ngân sách cấp xã',
  },

  /**
   * sắp xếp theo: để thiết lập các giá trị của nhóm dữ liệu
   * pqkhanh 16.05.2024
   */
  GroupDataOrderBy: {
    Name: 'Tên',
    Code: 'Mã',
  },

  /**
   * kiểu sắp xếp
   * pqkhanh 16.05.2024
   */
  TypeOrderBy: {
    FromAToZ: 0,
    FromZToA: 1,
  },

  /**
   * kiểu Số thứ tự
   * pqkhanh 16.05.2024
   */
  NumericalType: {
    Capital: 0, // chữ viết hoa
    Roman: 1, // ký tự la mã
    Number: 2, // số
    SubsequentNumber: 3, // đánh số theo cấp cha
    LowerCaseLetter: 4, // chữ cái thường
    Empty: 5, // trống
  },

  /**
   * Vị trí dòng tổng số trên mẫu thuyết minh
   * pqkhanh 16.05.2024
   */
  PositionVisibleSummary: {
    FirstRow: 0, // dòng đầu tiên
    LastRow: 1, // dòng cuối cùng
  },

  /**
   * Vị trí hiển thị dữ liệu tổng của nhóm trên mẫu thuyết minh
   * pqkhanh 16.05.2024
   */
  PositionVisibleRowSummaryGroup: {
    NameGroupAndRowSummaryInFirstRow: 0, // Tên nhóm & dòng tổng nhóm ở trên dữ liệu chi tiết
    NameGroupInFirstRowAndRowSummaryInLastRow: 1, // Tên nhóm ở trên & dòng tổng nhóm ở dưới dữ liệu chi tiết
    NameGroupNoDisplayRowAndRowSummaryInLastRow: 2, // Dòng tổng nhóm ở dưới dữ liệu chi tiết, không hiển thị tên nhóm
  },

  /**
   * bộ điều kiện
   * pqkhanh 17.05.2024
   */
  SetCondition: {
    And: 'Và', // và
    Or: 'Hoặc', // hoặc
  },

  /**
   * hàm đối chiếu
   */
  CompareOperator: {
    Equals: 'Bằng',
    GreaterThan: 'Lớn hơn',
    LessThan: 'Nhỏ hơn',
    GreaterThanEquals: 'Lớn hơn hoặc bằng',
    LessThanEquals: 'Nhỏ hơn hoặc bằng',
    NotEquals: 'Khác',
    In: 'Thuộc',
  },
  /**
   * data type view hiển thị
   * 0: STT, 1: Tên nhóm/dòng dữ liệu, 2: Dữ liệu, 3 Công thức, 4: Tự nhập 5: Tổng, 6: Trống, 7: Đếm, 8: Trung bình
   */
  ReportExcelFieldType: {
    Order: 0, //Ô số thứ tự của dòng tổng nhóm
    Name: 1, //Ô ngữ cảnh
    Data: 2, //Ô dữ liệu theo trường dữ liệu
    Formula: 3, //Ô dữ liệu theo công thức
    FreeText: 4, //Ô dữ liệu tự nhập
    Summary: 5, //Dòng tổng nhóm: tổng
    Empty: 6, //Dòng tổng nhóm: trống
    Count: 7, //Dòng tổng nhóm: đếm
    Average: 8, //Dòng tổng nhóm: trung bình cộng
    Concat: 9, //Dòng tổng nhóm: Ghép chuỗi
  },
  /**
   * kiểu dữ liệu dạng Text
   */
  ReportExcelFieldTypeText: {
    Summary: '[Tổng]', //Dòng tổng nhóm: tổng
    Empty: 'Để trống', //Dòng tổng nhóm: trống
    Count: '[Đếm]', //Dòng tổng nhóm: đếm
    Average: '[Trung bình]', //Dòng tổng nhóm: trung bình cộng
    Concat: '[Ghép dữ liệu]', //Dòng tổng nhóm: ghép chuỗi
  },
  /**
   * Hình thức lấy dữ liệu:
   * 5-Hiển thị theo giá trị trường dữ liệu,
   * 10-Hiển thị theo công thức,
   * 15-Hiển thị theo giá trị điều kiện,
   * 20-Hiển thị giá trị cố định
   */
  ExtraFieldType: {
    None: null,
    Model: 5,
    Formula: 10,
    Condition: 15,
    Constant: 20,
    StringValue: 25,
    Summary: 30,
  },
  /**
   * Giá trị trong chuỗi
   * 1 - Free text
   * 2 - Trường dữ liệu
   */
  DataStringType: {
    Text: 1,
    Model: 2,
  },
  /**
   * Loại thu
   */
  RevenueSuperiorType: {
    RevenueBudget: 1, //thu NSNN
    RevenueOther: 2, // thu khác
  },
  /**
   * Loại thu khác
   */
  RevenueSuperiorType: {
    InBalance: 1, // trong cân đối
    OutBalance: 2, // ngoài cân đối
  },
  BudgetDistributionInformationType: {
    Central: '1 - Ngân sách cấp trung ương',
    Province: '2 - Ngân sách cấp tỉnh',
    District: '3 - Ngân sách cấp huyện',
    Ward: '4 - Ngân sách cấp xã',
  },
  AutonomyType: {
    SeflFunding: 'Đơn vị hành chính được giao tự chủ kinh phí',
    NoSeflFunding: 'Đơn vị hành chính không được giao tự chủ kinh phí',
    PublicAnyRegular: 'Đơn vị SNCL tự bảo đảm một phần chi thường xuyên',
    PublicRegularInvest: 'Đơn vị SNCL tự bảo đảm chi thường xuyên và chi đầu tư',
    PublicRegular: 'Đơn vị SNCL tự bảo đảm chi thường xuyên',
    PublicGovernment: 'Đơn vị SNCL do Nhà nước bảo đảm chi thường xuyên',
    Other: 'Các đơn vị khác',
  },
  // In báo cáo tại đâu
  ReportBusiness: {
    ReportMenu: 1, // In tại màn hình danh sách báo cáo
    Other: 2, // in tại màn hình khác
  },
  /**
   * Ký hiệu phân biệt các Mode dữ liệu của Cell
   */
  SymbolModeCell: {
    Model: 'DL', //Theo trường dữ liệu
    Formula: 'CT', //theo công thức giữa các trường
    StringValue: 'GC', //Theo Ghép chuỗi hiểu thị
    Summary: 'OT', //Group dữ liệu
    TableFormula: 'TF', //Theo công thức của bảng dữ liệu
  },

  OrderType: {
    Empty: 0,
    Number: 1,
    Roman: 2,
    Uppercase: 3,
    Lowercase: 4,
  },

  /**
   * Enum cho tab kiểm tra biên bản cho đơn vị tổng hợp
   * @author NHCUONG 21.06.2024
   */
  AuditEstimateArrgrateTabType: {
    /**
     * Chi thường xuyên
     */
    Regular: 0,

    /**
     * Chi CTMT, DA
     */
    Project: 1,
    /**
     * Invest
     */
    Invest: 3,

    /**
     * phí, lệ phí
     */
    Fees: 4,

    Businees: 5,
  },

  // Co hien thi chi tiet hay khong
  IsAuditDetailOrg: {
    Default: 1,
    Detail: 2,
  },
  RecordsPerPage: {
    Ten: '10 bản ghi trên 1 trang',
    Twenty: '20 bản ghi trên 1 trang',
    Thirty: '30 bản ghi trên 1 trang',
    Fifty: '50 bản ghi trên 1 trang',
    Hundred: '100 bản ghi trên 1 trang',
  },

  WorkbookDefaultNames: [
    {
      FieldCode: 'MLCSM',
      FieldName: 'Mức lương cơ sở mới',
      Value: 2340000,
    },
    {
      FieldCode: 'MLCS',
      FieldName: 'Mức lương cơ sở',
      Value: 1800000,
    },
  ],

  ExplanatoryGeneralFields: [
    {
      FieldCode: 'CT_TENDONVI',
      FieldName: 'Tên đơn vị',
    },
    {
      FieldCode: 'CT_MAQHNS',
      FieldName: 'Mã QHNS',
    },
    {
      FieldCode: 'CT_CAPNGANSACH',
      FieldName: 'Cấp ngân sách',
    },
    {
      FieldCode: 'CT_HINHTHUCTUCHU',
      FieldName: 'Hình thức tự chủ',
    },
    {
      FieldCode: 'CT_TINHTP',
      FieldName: 'Tỉnh/Thành phố',
    },
    {
      FieldCode: 'CT_QUANHUYEN',
      FieldName: 'Quận/Huyện',
    },
    {
      FieldCode: 'CT_XAPHUONG',
      FieldName: 'Xã/Phường',
    },
    {
      FieldCode: 'CT_DIABAN',
      FieldName: 'Địa bàn',
    },
    {
      FieldCode: 'LINHVUC',
      FieldName: 'Lĩnh vực',
    },
    {
      FieldCode: 'CHUONG',
      FieldName: 'Chương',
    },
    {
      FieldCode: 'NGUON',
      FieldName: 'Nguồn kinh phí',
    },
    {
      FieldCode: 'LOAI',
      FieldName: 'Loại',
    },
    {
      FieldCode: 'KHOAN',
      FieldName: 'Khoản',
    },
    {
      FieldCode: 'TCTK',
      FieldName: 'Tiêu chí thống kê',
    },
    {
      FieldCode: 'MLCSM',
      FieldName: 'Mức lương cơ sở mới',
    },
    {
      FieldCode: 'MLCS',
      FieldName: 'Mức lương cơ sở',
    },
  ],

  PrintReportMode: {
    DEFAULT: 0, //In mặc định
    LDT: 5, //In ở lập dự toán đơn vị cấp dưới
    LDT_TH: 10, //In ở tổng hợp lập dự toán

    LDT_NOP: 15, //In ở nộp dự toán
    LDT_NOP_CT: 20, //In ở nộp dự toán

    LDT_GT: 25, //In ở nộp dự toán gửi trả
    LDT_GT_CT: 30, //In ở nộp dự toán gửi trả chi tiết

    DTNC: 35, //In ở dự toán nhu cầu
    DTNC_CT: 40, //In ở chi tiết dự toán nhu cầu

    KTDT: 45, //In ở kiểm tra dự toán
    KTDT_CT: 50, //In ở chi tiết kiểm tra dự toán

    PTC_THKT_TH: 55, //In ở tổng hợp kiểm tra ở PTC
    PTC_THKT_VIEW: 56, //In ở tổng hợp kiểm tra ở PTC view thuyết minh
    PTC_THKT_SUMMARY: 57, //In ở tổng hợp kiểm tra ở PTC tab tổng hợp thuyết minh

    PTC_LCD_VIEW: 60, //In ở lập và cân đối view thuyết minh,
    PTC_LCD_SUMMARY: 65, //In ở lập và cân đối tab tổng hợp thuyết minh,
    PTC_LCD_TH: 70, //In ở tổng hợp lập dự toán lập và cân đối,
    PTC_LCD_TH_CT: 75, //In ở tổng hợp lập dự toán lập và cân đối,

    CQSN_THKT_TH: 80, //In ở tổng hợp kiểm tra ở CQSN
    CQSN_THKT_VIEW: 81, //In ở tổng hợp kiểm tra ở CQSN view thuyết minh
    CQSN_THKT_SUMMARY: 82, //In ở tổng hợp kiểm tra ở CQSN tab tổng hợp thuyết minh

    CQSN_LDT_VIEW: 85, //In ở lập dự toán toàn ngành ở chủ quản sự nghiệp view thuyết minh
    CQSN_LDT_SUMMARY: 90, //In ở lập dự toán toàn ngành ở chủ quản sự nghiệp tổng hợp thuyết minh
    CQSN_LDT_TH: 95, //In ở tổng hợp lập dự toán ở chủ qunar sự nhgiệp

    CQSN_LDT_NOP_VIEW: 100, //In ở nộp dự toán ở CQSN - chi tiết đơn vị
    CQSN_LDT_NOP_SUMMARY: 105, //In ở nộp dự toán CQSN - tổng hợp đơn vị
    CQSN_LDT_NOP_TH: 110, //In ở tổng hợp nộp dự toán CQSN

    CQSN_LDT_GT_TH: 115, // In ở nộp dự toán gửi trả CQSN
    CQSN_LDT_GT_VIEW: 120, //In ở gửi trả dự toán CQSN (mode: không chi tiết theo đơn vị)
    CQSN_LDT_GT_SUMMARY: 125, //In ở chi tiết gửi trả dự toán CQSN (mode: không chi tiết theo đơn vị)

    CQSN_LDT_GT_VIEW_ORG: 130, //In ở gửi trả dự toán CQSN (mode: chi tiết theo đơn vị)
    CQSN_LDT_GT_SUMMARY_ORG: 135, //In ở chi tiết gửi trả dự toán CQSN (mode: chi tiết theo đơn vị)
    CQSN_LDT_GT_TH_ORG: 140, //In ở chi tiết gửi trả dự toán CQSN (mode: chi tiết theo đơn vị, màn hình tổng hợp dự toán)
    CQSN_LDT_GT_TH_ORG_DETAIL: 145, //In ở chi tiết gửi trả dự toán CQSN (mode: chi tiết theo đơn vị, màn hình master của từng đơn vị)

    DTNC_CQSN_VIEW: 150, //In ở dự toán nhu cầu (PTC kiểm tra CQSN)
    DTNC_CQSN_SUMMARY: 155, //In ở chi tiết dự toán nhu cầu (PTC kiểm tra CQSN)
    DTNC_CQSN_TH: 160, //In ở chi tiết dự toán nhu cầu (PTC kiểm tra CQSN)

    KTDT_CQSN_VIEW: 165, //In ở kiểm tra dự toán (PTC kiểm tra CQSN, mode: không chi tiết theo đơn vị)
    KTDT_CQSN_SUMMARY: 170, //In ở chi tiết kiểm tra dự toán (PTC kiểm tra CQSN, mode: không chi tiết theo đơn vị)
    KTDT_CQSN_TH: 175, //In ở chi tiết kiểm tra dự toán (PTC kiểm tra CQSN, mode: không chi tiết theo đơn vị)

    KTDT_CQSN_VIEW_ORG: 180, //In ở kiểm tra dự toán (PTC kiểm tra CQSN, mode: chi tiết theo đơn vị)
    KTDT_CQSN_SUMMARY_ORG: 185, //In ở chi tiết kiểm tra dự toán (PTC kiểm tra CQSN, mode: chi tiết theo đơn vị)
    KTDT_CQSN_TH_ORG: 190, //In ở chi tiết kiểm tra dự toán (PTC kiểm tra CQSN, mode: chi tiết theo đơn vị, màn hình tổng hợp dự toán)
    KTDT_CQSN_TH_ORG_DETAIL: 195, //In ở chi tiết kiểm tra dự toán (PTC kiểm tra CQSN, mode: chi tiết theo đơn vị, màn hình master của từng đơn vị)

    PTC_NOP_TH: 200, //In ở tổng hợp nộp dự toán PTC,
    PTC_NOP_CT: 215, // In ở tab tổng hợp thuyết minh của nộp dự toán PTC
    PTC_DT_TH: 216, // In ở tab cân đối của lập và cân đới PTC

    STC_DTNC_PTC: 240, //In ở dự toán nhu cầu STC
    STC_DTNC_PTC_CT: 245, //In ở chi tiết dự toán nhu cầu STC

    STC_DTKT_PTC: 250, //In ở kiểm tra dự toán STC - Đơn vị PTC
    STC_DTKT_SN: 251, //In ở kiểm tra dự toán STC - đơn vị Sự nghiệp
    STC_DTKT_CQSN: 252, //In ở kiểm tra dự toán STC - đơn vị CQSN
    STC_DTKT_CQSN_ORG: 253, //In ở kiểm tra dự toán STC - đơn vị CQSN
    STC_DTKT_PTC_CT: 255, //In ở chi tiết kiểm tra dự toán STC

    STC_THKT_PTC: 260, //In ở tổng hợp kiểm tra dự toán STC
    STC_THKT_SN: 261, //In ở tổng hợp kiểm tra dự toán STC - Đơn vị cấp tỉnh

    LDN_TH: 265, //In ở view tổng hợp - đơn vị SDNS lập dự toán đầu năm
    LDN_TH_DETAIL: 266, //In ở view tổng hợp - đơn vị SDNS lập dự toán đầu năm - Xem chi tiết nhiệm vụ
    LDN_NOP: 270, //In ở view tổng hợp - đơn vị SDNS lập dự toán đầu năm
    LDN_NKT: 273, // IN ở view nhận kết quả ktra - dự toán đầu năm

    STC_PB_PTC: 275, //STC phân bổ khối huyện

    LDN_LDT: 280, //In tại Lập dự toán đầu năm - Chi thường xuyên

    DTNC_INITIAL: 285, //In ở kiểm tra dự toán nhu cầu đầu năm

    KTDT_CT_INITIAL: 290, //In ở kiểm tra dự toán nhu cầu đầu năm

    LDN_CQSN_THKT_VIEW: 295, //In ở tổng hợp kiểm tra ở CQSN view thuyết minh - Lập dự toán đầu năm
    LDN_CQSN_THKT_SUMMARY: 296, //In ở tổng hợp kiểm tra ở CQSN tab tổng hợp thuyết minh - Lập dự toán đầu năm
    LDN_CQSN_THKT: 297, //In ở tổng hợp kiểm tra ở CQSN - Lập dự toán đầu năm
    KTDT_INITIAL: 400, // In thuyết minh kiểm tra dự toán đầu năm

    CQSN_LDN_TH: 300, //Chủ quản sự nghiệp lập toàn ngành dự toán đầu năm
    CQSN_LDN_TH_SUMMARY: 301, //Chủ quản sự nghiệp lập toàn ngành dự toán đầu năm - thuyết minh tổng hợp theo nhiệm vụ
    CQSN_LDN_TH_VIEW: 302, //Chủ quản sự nghiệp lập toàn ngành dự toán đầu năm - chi tiết đơn vị theo nhiệm vụ

    REPORT: 500, // In tại báo cáo
  },

  /**
   * Ngân sách cấp
   */
  BudgetType: {
    AllDistrict: 'Ngân sách toàn huyện',
    District: 'Ngân sách cấp huyện',
    Ward: 'Ngân sách cấp xã',
  },
  /**
   * xem theo
   */
  ViewWith: {
    Summary: 'Tổng hợp',
    DetailOrg: 'Chi tiết đơn vị',
  },
  OrgReportTypes: [
    { orgReportType: 1, name: 'Sở Tài chính', display: 'Mẫu tổng hợp toàn Tỉnh/Thành phố', orgPackCodeType: 1 },
    { orgReportType: 2, name: 'Phòng Tài chính', display: 'Mẫu tổng hợp toàn Quận/Huyện', orgPackCodeType: 2 },
    { orgReportType: 3, name: 'Đơn vị tổng hợp dự toán', display: 'Mẫu tổng hợp dự toán', orgPackCodeType: 5 },
    {
      orgReportType: 4,
      name: 'Đơn vị sử dụng ngân sách',
      display: 'Mẫu dành cho đơn vị sử dụng ngân sách',
      orgPackCodeType: 4,
    },
    { orgReportType: 5, name: 'Xã/Phường', display: 'Mẫu dành cho Xã/Phường', orgPackCodeType: 3 },
  ],

  ReportSummaryType: {
    DistrictAndCommune: 'Ngân sách toàn huyện',
    District: 'Ngân sách cấp huyện',
    Commune: 'Ngân sách cấp xã',
  },
  /**
   * Trạng thái mẫu in - giá trị
   */
  StatusReportCustomValue: {
    NOSEND: 0,
    SEND: 5,
    UPDATE: 10,
  },
  /**
   * Trạng thái mẫu in - tên
   */
  StatusReportCustomText: {
    NOSEND: 'Chưa gửi',
    SEND: 'Đã gửi',
    UPDATE: 'Cập nhật',
  },
  /**
   * Loại mẫu in
   */
  ReportCustomType: {
    REPORT: 5,
    EXPLANATION: 10,
  },
  /**
   * Loại mẫu in
   */
  ReportCustomTypeText: {
    REPORT: 'Báo cáo',
    EXPLANATION: 'Thuyết minh',
  },
  /**
   * Combobox lọc trạng thái của mẫu in
   */
  ComboboxStatusReportCustom: [
    { value: -1, name: 'Tất cả' },
    { value: 0, name: 'Chưa gửi' },
    { value: 5, name: 'Đã gửi' },
    { value: 10, name: 'Cập nhật' },
  ],

  // Loại báo cáo
  ReportType: {
    Static: 1, // báo cáo tĩnh
    Dynamic: 3, // báo cáo động
    Unprintable: 7, // Báo cáo chưa tồn tại
    File: 8, // Báo cáo biểu mẫu
    ReportCustom: 9, // Báo cáo tùy chỉnh
  },

  //Cấu hình chèn ô
  InsertOptions: {
    ShiftCellsRight: 1,
    ShiftCellsDown: 2,
    EntireRow: 3,
    EntireColumn: 4,
  },
  //Kích thước khổ giấy
  PaperSizeType: {
    Custom: 0,
    PaperLetter: 1,
    PaperLetterSmall: 2,
    PaperTabloid: 3,
    PaperLedger: 4,
    PaperLegal: 5,
    PaperStatement: 6,
    PaperExecutive: 7,
    PaperA3: 8,
    PaperA4: 9,
    PaperA4Small: 10,
    PaperA5: 11,
    PaperB4: 12,
    PaperB5: 13,
    PaperFolio: 14,
    PaperQuarto: 15,
    Paper10x14: 16,
    Paper11x17: 17,
    PaperNote: 18,
    PaperEnvelope9: 19,
    PaperEnvelope10: 20,
    PaperEnvelope11: 21,
    PaperEnvelope12: 22,
    PaperEnvelope14: 23,
    PaperCSheet: 24,
    PaperDSheet: 25,
    PaperESheet: 26,
    PaperEnvelopeDL: 27,
    PaperEnvelopeC5: 28,
    PaperEnvelopeC3: 29,
    PaperEnvelopeC4: 30,
    PaperEnvelopeC6: 31,
    PaperEnvelopeC65: 32,
    PaperEnvelopeB4: 33,
    PaperEnvelopeB5: 34,
    PaperEnvelopeB6: 35,
    PaperEnvelopeItaly: 36,
    PaperEnvelopeMonarch: 37,
    PaperEnvelopePersonal: 38,
    PaperFanfoldUS: 39,
    PaperFanfoldStdGerman: 40,
    PaperFanfoldLegalGerman: 41,
    PaperISOB4: 42,
    PaperJapanesePostcard: 43,
    Paper9x11: 44,
    Paper10x11: 45,
    Paper15x11: 46,
    PaperEnvelopeInvite: 47,
    PaperLetterExtra: 50,
    PaperLegalExtra: 51,
    PaperTabloidExtra: 52,
    PaperA4Extra: 53,
    PaperLetterTransverse: 54,
    PaperA4Transverse: 55,
    PaperLetterExtraTransverse: 56,
    PaperSuperA: 57,
    PaperSuperB: 58,
    PaperLetterPlus: 59,
    PaperA4Plus: 60,
    PaperA5Transverse: 61,
    PaperJISB5Transverse: 62,
    PaperA3Extra: 63,
    PaperA5Extra: 64,
    PaperISOB5Extra: 65,
    PaperA2: 66,
    PaperA3Transverse: 67,
    PaperA3ExtraTransverse: 68,
    PaperJapaneseDoublePostcard: 69,
    PaperA6: 70,
    PaperJapaneseEnvelopeKaku2: 71,
    PaperJapaneseEnvelopeKaku3: 72,
    PaperJapaneseEnvelopeChou3: 73,
    PaperJapaneseEnvelopeChou4: 74,
    PaperLetterRotated: 75,
    PaperA3Rotated: 76,
    PaperA4Rotated: 77,
    PaperA5Rotated: 78,
    PaperJISB4Rotated: 79,
    PaperJISB5Rotated: 80,
    PaperJapanesePostcardRotated: 81,
    PaperJapaneseDoublePostcardRotated: 82,
    PaperA6Rotated: 83,
    PaperJapaneseEnvelopeKaku2Rotated: 84,
    PaperJapaneseEnvelopeKaku3Rotated: 85,
    PaperJapaneseEnvelopeChou3Rotated: 86,
    PaperJapaneseEnvelopeChou4Rotated: 87,
    PaperJISB6: 88,
    PaperJISB6Rotated: 89,
    Paper12x11: 90,
    PaperJapaneseEnvelopeYou4: 91,
    PaperJapaneseEnvelopeYou4Rotated: 92,
    PaperPRC16K: 93,
    PaperPRC32K: 94,
    PaperPRCBig32K: 95,
    PaperPRCEnvelope1: 96,
    PaperPRCEnvelope2: 97,
    PaperPRCEnvelope3: 98,
    PaperPRCEnvelope4: 99,
    PaperPRCEnvelope5: 100,
    PaperPRCEnvelope6: 101,
    PaperPRCEnvelope7: 102,
    PaperPRCEnvelope8: 103,
    PaperPRCEnvelope9: 104,
    PaperPRCEnvelope10: 105,
    PaperPRC16KRotated: 106,
    PaperPRC32KRotated: 107,
    PaperPRCBig32KRotated: 108,
    PaperPRCEnvelope1Rotated: 109,
    PaperPRCEnvelope2Rotated: 110,
    PaperPRCEnvelope3Rotated: 111,
    PaperPRCEnvelope4Rotated: 112,
    PaperPRCEnvelope5Rotated: 113,
    PaperPRCEnvelope6Rotated: 114,
    PaperPRCEnvelope7Rotated: 115,
    PaperPRCEnvelope8Rotated: 116,
    PaperPRCEnvelope9Rotated: 117,
    PaperPRCEnvelope10Rotated: 118,
    PaperB3: 300,
    PaperBusinessCard: 301,
    PaperThermal: 302,
  },
  /**
   * Id của các command trong context menu workbook
   */
  idCommandContextMenu: {
    InsertRow: 'InsertRow',
    InsertRowCustom: 'InsertRowCustom',
    InsertColumnDetail: 'InsertColumnDetail',
    InsertColumnCustom: 'InsertColumnCustom',
    InsertColumn: 'InsertColumn',
    DeleteRow: 'DeleteRow',
    DeleteColumn: 'DeleteColumn',
    HideRow: 'HideRow',
    UnhideRow: 'UnhideRow',
    HideColumn: 'HideColumn',
    UnhideColumn: 'UnhideColumn',
    CopyCustom: 'CopyCustom',
    CutCustom: 'CutCustom',
    PasteCustom: 'PasteCustom',
    AddCellDetail: 'AddCellDetail',
    AddCellType: 'AddCellType',
    AddColumnTable: 'addColumnTable',
    showRowsTableCondition: 'showRowsTableCondition',
    PasteRow: 'PasteRow',
    InsertCutRow: 'InsertCutRow',
    CutRow: 'CutRow',
    Filter: 'Filter',
  },

  ColorTextExplanation: {
    Default: '#000000',
    Suggest: '#C1C3C7',
  },
  TypeContextMenuWorkbook: {
    SetupPrintRow: 'SetupPrintRow',
    SetupPrintCol: 'SetupPrintCol',
    SetupPrint: 'SetupPrint',
  },
  ListCeilingExpenseStatus: {
    NotSentYet: 'Chưa gửi',
    Sent: 'Đã gửi',
  },

  RangeStatus: {
    None: 1,
    NotSelected: 2,
    Selecting: 3,
    Selected: 4,
  },
  LayoutExamineThreeYear: {
    HasLimit: 'layoutExamineThreeYearLimit',
    NotLimit: 'layoutExamineThreeYear',
  },
  LayoutRevenueExamineBusinessThreeYear: {
    HasLimit: 'examineMasterRevenueThreeYearBusinessDetail',
    NotLimit: 'examineMasterRevenueThreeYearBusinessDetail',
  },
  //Nguồn dữ liệu tùy chỉnh báo cáo
  ReportCustomCategoryDataSource: {
    Estimate: 'Dự toán',
    Explanation: 'Thuyết minh',
  },

  //Nguồn dữ liệu dự toán tùy chỉnh báo cáo
  ReportCustomDataSource: {
    CHI_DAUTU: 'Chi đầu tư',
    CHI_TX: 'Chi thường xuyên',
    CHI_CTMT: 'Chi CTMT, mục tiêu khác',
    CHI_PHI_LEPHI: 'Chi phí lệ phí',
    CHI_HDSNDV: 'Chi hoạt động sự nghiệp dịch vụ',
    CHI_KHAC: 'Chi khác theo quy định của pháp luật',
    CHITXCOCAUTX: 'Chi thường xuyên và chi CTMT (Cơ cấu: Thường xuyên)',
    CHITXCOCAUDT: 'Chi đầu tư và chi CTMT (Cơ cấu: Đầu tư)',
    CST: 'Cơ sở tính lập dự toán',
    THU_NSNN: 'Thu ngân sách nhà nước',
    THU_PHI_LEPHI: 'Thu phí lệ phí',
    THU_HDSNDV: 'Thu hoạt động sự nghiệp dịch vụ',
    THU_KHAC: 'Thu khác theo quy định của pháp luật',
  },

  FormulaType: {
    SUM: 'Tổng',
    COUNT: 'Đếm',
    AVG: 'Trung bình',
  },

  DataSourceEstimate: {
    MA_NOIDUNG: 'Nội dung',
    MA_LINHVUC: 'Lĩnh vực',
    MA_CHUONG: 'Chương',
    MA_NGUON: 'Nguồn',
    MA_LOAI: 'Loại',
    MA_KHOAN: 'Khoản',
    MA_TCTK: 'Tiêu chí thống kê',
    MA_TINHCHAT: 'Tính chất',
  },
  // Trạng thái kiểm tra dự toán theo nguồn 3 năm
  AuditExamineThreeYearStatus: {
    NotCheck: 'Chưa kiểm tra',

    Checked: 'Đã kiểm tra',
  },

  DataComboReportCustomDataSource: [
    { key: 1, code: 'CST', value: 'Cơ sở tính lập dự toán', org_pack_code: [1, 2, 3, 4, 5], type: 1 },

    { key: 2, code: 'CHI_TX', value: 'Chi thường xuyên', org_pack_code: [1, 2, 3, 4, 5], type: 1 },
    { key: 3, code: 'CHI_DAUTU', value: 'Chi đầu tư', org_pack_code: [1, 2, 3, 4, 5], type: 1 },
    { key: 4, code: 'CHI_CTMT', value: 'Chi CTMT, mục tiêu khác', org_pack_code: [1, 2, 3, 4, 5], type: 1 },
    { key: 5, code: 'CHI_PHI_LEPHI', value: 'Chi phí lệ phí', org_pack_code: [1, 2, 3, 4, 5], type: 1 },
    { key: 6, code: 'CHI_HDSNDV', value: 'Chi hoạt động sự nghiệp dịch vụ', org_pack_code: [1, 2, 3, 4, 5], type: 1 },
    { key: 7, code: 'CHI_KHAC', value: 'Chi khác theo quy định của pháp luật', org_pack_code: [1, 2, 3, 4, 5], type: 1 },

    { key: 8, code: 'THU_NSNN', value: 'Thu ngân sách nhà nước', org_pack_code: [1, 2, 3, 4, 5], type: 1 },
    { key: 9, code: 'THU_PHI_LEPHI', value: 'Thu phí lệ phí', org_pack_code: [1, 2, 3, 4, 5], type: 1 },
    { key: 10, code: 'THU_HDSNDV', value: 'Thu hoạt động sự nghiệp dịch vụ', org_pack_code: [1, 2, 3, 4, 5], type: 1 },
    { key: 11, code: 'THU_KHAC', value: 'Thu khác theo quy định của pháp luật', org_pack_code: [1, 2, 3, 4, 5], type: 1 },
  ],

  FieldEstimateReportPrint: {
    SDTNT: 'Số dự toán năm trước',
    STHNT: 'Số thực hiện năm trước',
    SDTNHH: 'Số dự toán năm hiện hành',
    STHNHH: 'Ước thực hiện năm hiện hành',
    SDTNKH: 'Số dự toán năm kế hoạch',
  },

  FieldEstimateDisplayReportPrint: [
    { key: 1, field_code: 'MACHUONG', field_name: 'Mã chương', data_table: 13 },
    { key: 2, field_code: 'TENCHUONG', field_name: 'Tên chương', data_table: 13 },
    { key: 3, field_code: 'MANGUON', field_name: 'Mã nguồn', data_table: 13 },
    { key: 4, field_code: 'TENNGUON', field_name: 'Tên nguồn', data_table: 13 },
    { key: 5, field_code: 'MAKHOAN', field_name: 'Mã khoản', data_table: 13 },
    { key: 6, field_code: 'TENKHOAN', field_name: 'Tên khoản', data_table: 13 },
  ],

  GroupType: {
    Content: 5,
    Group: 10,
    GroupSummary: 15,
    Summary: 20,
    GroupAdvance: 25,
    GroupSummaryAdvance: 30,

    HContent: 35,
    HGroup: 40,
    HGroupSummary: 45,
    HSummary: 50,
    HGroupAdvance: 55,
    HGroupSummaryAdvance: 60,
  },

  FormatCell: {
    General: 'General',
    Number: '#,##0',
    Currency: '$#,##0.00',
    Accounting: '$ #,##0.00;$ (#,##0.00);$ "-"??;@',
    Short_Date: 'dd/mm/yyyy',
    Long_Date: 'dddd, mmmm dd, yyyy',
    Time: 'h:mm:ss AM/PM',
    Percentage: '0.00%',
    Scientific: '0.00E+00',
    Constant: '#,##0.00',
    Text: '@',
  },

  OrganizationUnderType: {
    OrganizationCode: 'Mã QHNS',
    OrganizationName: 'Tên đơn vị',
  },
  ModelSourceType: {
    Custom: 1,
    Dictionary: 2,
  },

  DictionarySourceType: {
    Section: 5,
    SubSection: 10,
  },

  TypeAudit: {
    AuditEstimate: 1, // Tab kiểm tra
    AuditReceive: 2, // Tab nhu cầu
  },

  TypeComboEstSubmit: {
    SubSection: 4,
  },

  MisaAvaDictionaryRegularType: {
    Add: 'Thêm mới',
    Update: 'Cập nhật',
    Existed: 'Đã tồn tại',
    Error: 'Không hợp lệ',
  },

  StatusRegular: {
    Enact: 'Danh mục cấp trên ban hành',
    Arise: 'Đã phát sinh số liệu',
  },

  /**
   * màn kiểm tra phòng qlns kt stc
   */
  AuditSummarySTCStatus: {
    NotCheck: 'Chờ kiểm tra',
    Return: 'Đã gửi trả',
    Completed: 'Đã hoàn thành',
  },

  ExpenseInvestType: {
    InvestCapital: 'Chi đầu tư theo nguồn',
    InvestField: 'Chi đầu tư theo lĩnh vực',
  },

  /**
   *
   */
  RouterCustomParam: [
    { key: 'createEstimate', name: 'Lập dự toán', sort: 0 },
    { key: 'begin-year-arrgrate', name: 'Lập dự toán nhu cầu', sort: 1 },
    { key: 'estimateArrgrateDetailTab', name: 'Chi tiết dự toán', sort: 2 },
    { key: 'estimateArrgrateExplanation', name: 'Thuyết minh', sort: 3 },
    { key: 'estimateArrgrateReferencesTab', name: 'Số liệu tham khảo', sort: 4 },
    { key: 'sector-wide-begin-year-estimate', name: 'Lập toàn ngành', sort: 5 },
    { key: 'estimateSectorWideDetailTab', name: 'Chi tiết dự toán toàn ngành', sort: 6 },
    { key: 'estimateSectorWideExplanationTab', name: 'Thuyết minh dự toán toàn ngành', sort: 7 },
    { key: 'estimateSectorWideReferencesTab', name: 'Số liệu tham khảo toàn ngành', sort: 8 },
    { key: 'estimateArrgrateRegularSummaryExplanation', name: 'Thuyết minh tổng hợp toàn ngành', sort: 9 },
    { key: 'begin-year', name: 'Lập dự toán nhu cầu', sort: 10 },
    { key: 'ExpenseBusiness', name: 'Chi HĐSN dịch vụ', sort: 11 },
    { key: 'RevenueBusiness', name: 'Thu HĐSN dịch vụ', sort: 12 },
    { key: 'RevenueFees', name: 'Thu phí lệ phí', sort: 13 },
    { key: 'ExpenseFees', name: 'Chi phí lệ phí', sort: 14 },
  ],

  KeyCache: {
    BeginYear_EstimateCategory: 'BeginYear_EstimateCategory',
  },

  /**
   *  Loại tiến trình áp dụng/ban hành
   */
  MessageTextProcess: {
    Apply: 'áp dụng',
    Publish: 'ban hành',
    TitleApply: 'Danh sách đơn vị áp dụng lỗi',
    TitlePublish: 'Danh sách đơn vị ban hành lỗi',
    SubTitleApply: 'Vui lòng thực hiện áp dụng lại hoặc liên hệ MISA để được trợ giúp',
    SubTitlePublish: 'Vui lòng thực hiện ban hành lại hoặc liên hệ MISA để được trợ giúp',
  },

  /**
   *  Loại quyết định phân bổ
   */
  DecisionType: {
    DecisionBeginYear: 'Giao đầu năm',
    DecisionAdditional: 'Giao điều chỉnh, bổ sung',
  },

  /**
   * Hình thức giao
   * NXHinh 22.01.2025
   */
  DeliverMethod: {
    Online: 'Trực tuyến',
    Offline: 'Truyền thống',
  },

  /**
   * Trạng thái quyết định giao
   * NXHinh 22.01.2025
   */
  DecisionStatus: {
    InUse: 'Còn hiệu lực',
    Return: 'Đã thu hồi',
  },

  /**
   *  Loại phương án phân bổ
   */
  ImplementType: {
    ImplementBeginYear: 'Dự toán đầu năm',
    ImplementAdditional: 'Dự toán bổ sung',
    ImplementAdjustment: 'Dự toán điều chỉnh',
  },

  /**
   *  Loại phương án phân bổ
   */
  ImplementTypeBeginYear: {
    ImplementBeginYear: 'Dự toán đầu năm',
    // ImplementAdditional: 'Dự toán bổ sung',
    // ImplementAdjustment: 'Dự toán điều chỉnh',
  },

  /**
   *  Trạng thái phương án phân bổ
   */
  AllocationImplementStatus: {
    NotApproved: 'Chưa duyệt',
    Approved: 'Đã duyệt',
    WaitApproved: 'Chờ duyệt',
    CantApproved: 'Không được duyệt',
  },

  /**
   *  Trạng thái quyết định giao
   */
  AllocationDeliverStatus: {
    NotDelivered: 'Chưa giao',
    Delivering: 'Chưa giao',
    Delivered: 'Đã giao',
    PartiallyDelivered: 'Đã giao',
    CancelDelivered: 'Đã thu hồi',
  },

  /**
   *  Loại quyết định giao
   */
  DeliverType: {
    DeliverBeginYear: 'Giao đầu năm',
    DeliverAdditional: 'Giao bổ sung',
    DeliverAdjustment: 'Giao điều chỉnh',
    DeliverAdditionalAdjustment: 'Giao bổ sung, điều chỉnh'
  },

  /**
   *  Loại quyết định giao
   */
  DeliverTypeCQSN: {
    DeliverBeginYear: 'Giao đầu năm',
    DeliverAdditionalAdjustment: 'Giao bổ sung, điều chỉnh'
  },

  /**
   *  Là chỉ tiêu
   */
  TargetRevenue: {
    Empty: '<<Trống>>',
    IsInWhich: 'Trong đó',
  },

  User: {
    AddUser: 'Thêm người dùng',
    EditUser: 'Sửa người dùng',
    AddRole: 'Thêm vai trò',
    EditRole: 'Sửa vai trò',
  },

  DataSourceType: {
    Explanation: 1,
    Estimate: 2,
  },

  SourceName: {
    Explanation: 'THUYETMINH',
    Salary: 'THUYETMINHLUONG',
    Regular: 'CHI_TX',
    CalculationBasis: 'CST',
  },

  OrganizationClassification: {
    None: '',

    Kintergarten: 'Khối mầm non',

    PrimarySchool: 'Khối tiểu học',

    SecondarySchool: 'Khối THCS',

    HighSchool: 'Khối THPT',

    InterLevelSchool12: 'Khối liên cấp 1, 2',

    InterLevelSchool23: 'Khối liên cấp 2, 3',

    InterLevelSchool123: 'Khối liên cấp 1, 2, 3',

    ContinuingEducation: 'Khối Trung tâm GDTX',

    IntermediateProfessionalSchool: 'Khối Trung cấp chuyên nghiệp',

    College: 'Khối Cao đẳng',

    University: 'Khối Đại học',

    Other: 'Khối đơn vị SDNS khác',
  },
  /**
   * Enum mode view tổng hợp chi tiết dự toán đầu năm
   * @author PTTAM2 25.03.2025
   */
  EstimateInitialSummaryDetailModeView: {
    /**
     *  Tách CTMT
     */
    SummaryDetailSeparateCTMT: 1,

    /**
     *  Không Tách CTMT
     */
    SummaryDetailMergeCTMT: 2,
  },
  // cấp ngân sách tỉnh
  OrganizationClassificationProvince: {
    HighSchool: 'Khối THPT',

    InterLevelSchool23: 'Khối liên cấp 2, 3',

    InterLevelSchool123: 'Khối liên cấp 1, 2, 3',

    ContinuingEducation: 'Khối Trung tâm GDTX',

    IntermediateProfessionalSchool: 'Khối Trung cấp chuyên nghiệp',

    College: 'Khối Cao đẳng',

    University: 'Khối Đại học',

    Other: 'Khối đơn vị SDNS khác',
  },

  // cấp ngân sách huyện
  OrganizationClassificationDistrict: {
    Kintergarten: 'Khối mầm non',

    PrimarySchool: 'Khối tiểu học',

    SecondarySchool: 'Khối THCS',

    InterLevelSchool12: 'Khối liên cấp 1, 2',

    ContinuingEducation: 'Khối Trung tâm GDTX',

    Other: 'Khối đơn vị SDNS khác',
  },

  EstInitialType: {
    Demand: 'Lập theo dự toán nhu cầu',

    Deliver: 'Lập theo quyết định giao',

    New: 'Lập mới',
  },

  EstInitialAggregateType: {
    Demand: 'Lập theo số kiểm tra cấp dưới',

    Deliver: 'Lập theo quyết định giao',

    New: 'Lập mới',
  },

  SectionKind: {
    Group: 'Nhóm',
    SubGroup: 'Tiểu nhóm',
    Item: 'Mục',
    SubItem: 'Tiểu mục',
  },

  AllocationMethod: {
    Field: 'Phân bổ theo lĩnh vực',
    Source: 'Phân bổ theo nguồn kinh phí',
  },

  AllocationMessage: {
    ErrorGetData: 'Không lấy được dữ liệu',
    SuccessGetData: 'Lấy dữ liệu thành công',
  },
  ReserveExpenseType: {
    Regular: 'Chi thường xuyên',
    Invest: 'Chi đầu tư',
    PreviousYearReserve: 'Dự toán dự phòng năm trước',
  },
  ALC_IS_DELIVERY_BUDGET_MODE: {
    RevenueAndSpending: 'revenueAndSpending',
    Revenue: 'revenue',
  },
  DataType: {
    /// <summary>
    /// Loại
    /// </summary>
    Kind: 'Loại',
    /// <summary>
    /// Chương
    /// </summary>
    Chapter: 'Chương',
    /// <summary>
    /// Khoản
    /// </summary>
    SubKind: 'Khoản',
    /// <summary>
    /// Nguồn
    /// </summary>
    Source: 'Nguồn',
    /// <summary>
    /// Tiêu chí thống kê
    /// </summary>
    Criteria: 'Tiêu chí thống kê',
    /// <summary>
    /// Nhiệm vụ
    /// </summary>
    Regular: 'Nhiệm vụ',
  },

  /**
   * Vị trí nhập liệu thuyết minh
   */
  ExplanatoryDataEntryMode: {
    DEFAULT: 0,
    LAP_DUTOAN: 5,
    LAP_CANDOI: 10,
    LAP_TOANNGANH: 15,
    LAPLAI_DUTOAN: 50,
  },

  ReversedFields: ['CT_MAQHNS', 'CHUONG', 'LOAI', 'KHOAN', 'NGUON'],

  /**
   * Enum mode view SCQ tổng hợp chi nsnn
   * @author NHCUONG 27.02.2025
   */
  AllocationImplementSummaryModeView: {
    /**
     * Tổng hợp - Tách CTMT
     */
    SCQSummarySeparateCTMT: 1,

    /**
     * Tổng hợp - Không Tách CTMT
     */
    SCQSummaryNotSeparateCTMT: 2,

    /**
     * Chi tiết nhiệm vụ - Tách CTMT
     */
    SCQSeparateCTMT: 3,

    /**
     * Chi tiết nhiệm vụ - Không tách CTMT
     */
    SCQNotSeparateCTMT: 4,

    /**
     * Chi tiết nhiệm vụ - Tách Cân đối, BSMT
     */
    SCQSeparateBalanceBSMT: 5,

    /**
     * Chi tiết Mục, Tiểu mục
     */
    SCQBudgetDetailItem: 6,
  },

  ReportCellType: {
    Model: 0,
    SummaryFormula: 1,
    Concat: 2,
    TableFormula: 3,
    Fixed: 4,
    SummaryConditionFormula: 5,
  },

  ReportRowType: {
    Normal: 0,
    Group: 1,
    Table: 2,
  },
  CategoryDataSource: {
    Estimate: 5,
    Explanation: 10,
    Salary: 15,
  },

  /**
   *  Trạng thái nộp dự toán đầu năm
   */
  SubmitEstInitialStatus: {
    NotApproved: 'Chưa nộp', // Chưa nộp
    WaitApproved: 'Chờ kiểm tra', // Chờ kiểm tra
    Approved: 'Đã duyệt', // Đã duyệt
    Edit: 'Cần sửa', // Cần sửa
  },

  EstimateDevisionType: {
    ByQuarter: 'Phân khai theo quý',
    ByMonth: 'Phân khai theo tháng',
    None: 'Không phân khai',
  },

  ReportSummaryStatus: {
    Fail: 0,
    Success: 5,
    Processing: 10,
    IsNotSummary: 15,
  },

  /**
   * Quyết định giao - tiết kiệm chi
   */
  ExpenseSavingType: {
    Unit: 'Đơn vị giữ',
    Budget: 'Ngân sách giữ',
    UnitAndBudget: 'Đơn vị giữ kinh phí tự chủ, Ngân sách giữ kinh phí không tự chủ',
  },

  ReportId: {
    NSH02_STC: '85917499-0f8d-11f0-b574-005056b386ee',
  },

  ComboboxTypeAuidtEstInitialSummarySCQ: {
    EXPENSE: [
      { name: 'Tách CTMT', value: 0, detail: false, isMerge: false },
      { name: 'Không tách CTMT', value: 1, detail: false, isMerge: true },
    ],
  },
  LayoutSummaryEstimateInitialCqsnByYear: {
    SUMMARY: 'summaryestimateintitialdetailbyyearTH',
    DETAIL: 'summaryestimateintitialdetailbyyear',
  },
  LayoutSummaryEstimateInitialCqsnByQuater: {
    SUMMARY: 'summaryestimateintitialdetailbyquaterTH',
    DETAIL: 'summaryestimateintitialdetailbyquater',
  },
  LayoutSummaryEstimateInitialCqsnByMonth: {
    SUMMARY: 'summaryestimateintitialdetailbymonthTH',
    DETAIL: 'summaryestimateintitialdetailbymonth',
  },

  EIAExpenseFeesRowType:
  {
    Master: 0,
    RevenueTitle: 1,
    RevenueFees: 2,
    ParentExpenseFees: 3,
    ExpenseFees: 4,
    RevenueUnknown: 5
  },
  /**
   * Tính chất hoạt động
   */
  BudgetSourceProperty: {
    AutonomyFunding: 'Kinh phí thực hiện chế độ tự chủ',
    NotAutonomyFunding: 'Kinh phí không thực hiện chế độ tự chủ',
  }
};
